<template>
  <v-container fluid class="pa-2" style="margin-top: 2%; max-width: 100%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudLinhas.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="dismissConfirmDialog">{{
                this.messageDismissButton }}</v-btn>
              <v-btn
                v-if="showConfirmButton && confirmDialogType === 'delete'"
                color="red accent-4"
                class="white--text"
                @click="deleteFromDatabase"
              >{{ this.messageConfirmButton }}</v-btn>
              <v-btn
                v-if="showConfirmButton && confirmDialogType === 'cliente'"
                color="red accent-4"
                class="white--text"
                @click="confirmClienteChange"
              >{{ this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialogTerminusOrder" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('crudLinhas.messages.systemMessage') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ $t('crudLinhas.map.dialogTerminusOrderBody') }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red accent-4" class="white--text" @click="dialogTerminusOrder = false">
            {{ $t('button.confirmOk') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <recursos-operacionais-split-layout
      ref="detalheSplit"
      :linha="linhaSelecionada"
      :additional-linhas="creatingLinha ? createBackdropLinhas : outrasLinhasSelecionadas"
      :preview-type="creatingLinha || !(linhaSelecionada && linhaSelecionada.id_linha) ? 'linha' : null"
      :preview-item="null"
      :initial-tab-key="initialDetailTabKey"
      :preferred-route-ids="publishedRouteIds"
      :historico-sessao-id="historicoSessaoId"
      :historico-sessao-origem-id="historicoSessaoOrigemId"
      :sentidos="sentidos"
      :token="token"
      :can-edit="canEdit"
      :can-insert="canInsert"
      :tipos-cerca="tiposCerca"
      :tipos-rota="tiposRota"
      :parametros-total="selecionadas.length"
      :parametros-page.sync="parametrosPage"
      :parametros-label="parametrosLabel"
      :linha-create-preview-rotas="creatingLinha ? createPreviewRotasNoMapa : []"
      :linha-create-preview-cerca="creatingLinha ? createPreviewCerca : null"
      :linha-create-preview-cercas-linha="creatingLinha ? createPreviewCercasNoMapa : []"
      :linha-create-preview-prefer-unidade="creatingLinha && createPreviewPreferUnidade"
      :cerca-create-select-route="creatingCercaNaLinha && cercaNaLinhaRotaId == null"
      :cerca-create-route-id.sync="cercaNaLinhaRotaId"
      @passengers-changed="onDetalheChanged"
      @cercas-changed="onDetalheChanged"
      @rotas-changed="onRotasDetalheChanged"
      @turnos-changed="onDetalheChanged"
      @parametros-save="saveParametros"
      @map-action="onMapAction"
    >
      <template #parametros>
        <v-form ref="formParametros" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox v-model="isSublinha" :label="$t('crudLinhas.form.fields.sublines')" color="primary"
                @change="isSublinhaChanged"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="10" md="10">
              <v-autocomplete v-model="linhaPrincipal" :items="linhas" item-text="nome_linha" return-object
                clearable :label="$t('crudLinhas.form.fields.selectMainLine')"
                :rules="[(v) => !!v || !isSublinha || $t('crudLinhas.validation.lineRequired')]"
                @change="linhaPrincipalChanged" :disabled="!isSublinha"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="9" md="9">
              <v-text-field v-model="editedItem.nome_linha" :label="$t('crudLinhas.form.fields.lineName')"
                :rules="[nomeLinhaRules]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field v-model="editedItem.lotacao_prevista"
                :label="$t('crudLinhas.form.fields.capacityPerTrip')" :rules="[lotacaoRules]"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="editedItem.descricao_linha"
                :label="$t('crudLinhas.form.fields.description')"
                rows="2" auto-grow clearable
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                item-value="id_empresa" clearable :label="$t('crudLinhas.form.fields.selectCompany')"
                :rules="[(v) => !!v || $t('crudLinhas.validation.companyRequired')]"
                :disabled="isScopedClienteCreateLock"
                @change="filtroEmpresaChanged"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="editedItem.id_cliente" :items="clientesPorEmpresa(editedItem.id_empresa)"
                item-text="nome_cliente" item-value="id_cliente" clearable
                :label="$t('crudLinhas.form.fields.selectClient')"
                :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
                @change="onClienteChange"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="2">
              <v-text-field v-model="editedItem.cod_linha" :label="$t('crudLinhas.form.fields.lineCode')"
                :rules="[codLinhaRules]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="2">
              <v-text-field v-model="editedItem.cod_integracao_linha"
                :label="$t('crudLinhas.form.fields.integrationCode')" :rules="[codIntegracaoLinhaRules]"
                clearable :hint="$t('crudLinhas.form.fields.integrationCodeHint')"
                persistent-hint></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="2" align-self="center">
              <v-switch v-model="isCircular" color="primary"
                :label="$t('crudLinhas.form.fields.circular')"></v-switch>
            </v-col>
            <v-col cols="12" sm="2" md="2" align-self="center">
              <v-switch v-model="editedItem.linha_intermunicipal"
                :label="$t('crudLinhas.form.fields.intermunicipal')" color="primary"></v-switch>
            </v-col>
            <v-col cols="12" sm="2" md="2" align-self="center">
              <v-switch v-model="editedItem.has_eta" :label="$t('crudLinhas.form.fields.eta')"
                color="primary"></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8">
              <v-autocomplete
                ref="unidadesField"
                v-model="unidadesLinhaIds"
                :items="unidades"
                item-text="descricao_unidade"
                item-value="id_unidade"
                multiple
                chips
                small-chips
                deletable-chips
                clearable
                :class="{ 'crud-linhas-field--highlight-label': highlightUnidadesField }"
                :loading="loadingUnidades"
              >
                <template v-slot:label>
                  <span :class="{ 'crud-linhas-label--highlight': highlightUnidadesField }">
                    {{ $t('crudLinhas.form.fields.selectUnits') }}
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3" align-self="center">
              <v-text-field v-model="velocidadeMaxima" :label="$t('crudLinhas.form.fields.maxSpeed')"
                :rules="[velocidadeMaximaRules]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" align-self="center">
              <v-switch v-model="alarmeVelocidadeMaxima" class="ma-2"
                :label="$t('crudLinhas.form.fields.maxSpeedAlarm')"
                @change="velocidadeMaximaChanged"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="3" align-self="center">
              <v-text-field v-model="toleranciaForaRota"
                :label="$t('crudLinhas.form.fields.routeDistanceLimit')" type="number" min="0"
                :rules="[(v) => (v === null || v >= 0) || $t('crudLinhas.validation.distanceMustBePositive')]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" align-self="center">
              <v-switch v-model="alarmeForaRota" color="primary"
                :label="$t('crudLinhas.form.fields.outOfRouteAlarm')"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="2" align-self="center">
              <v-switch v-model="isAtiva" color="primary"
                :label="$t('crudLinhas.form.fields.active')"></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="limiteTempoParado" :label="$t('crudLinhas.form.fields.stoppedTimeLimit')"
                :rules="[limiteTempoParadoRules]" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-switch v-model="alarmeTempoParado" color="primary"
                :label="$t('crudLinhas.form.fields.stoppedTimeAlarm')"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="limiteTempoLargada"
                :label="$t('crudLinhas.form.fields.departureTimeLimit')" :rules="[limiteTempoLargadaRules]"
                type="number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-switch v-model="atualizaInicioViagem" color="primary"
                :label="$t('crudLinhas.form.fields.updateTripStart')"></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.distancia_ida"
                :label="$t('crudLinhas.form.fields.distanceOutbound')" type="number"
                suffix="km" :hint="avisoDistancia('distancia_ida')"
                :persistent-hint="!!avisoDistancia('distancia_ida')"
                :class="{ 'crud-linhas-distancia--divergente': !!avisoDistancia('distancia_ida') }"
                :append-icon="avisoDistancia('distancia_ida') ? 'mdi-calculator' : undefined"
                @click:append="usarDistanciaCalculada('distancia_ida')"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.distancia_volta"
                :label="$t('crudLinhas.form.fields.distanceReturn')" type="number" suffix="km"
                :hint="avisoDistancia('distancia_volta')"
                :persistent-hint="!!avisoDistancia('distancia_volta')"
                :class="{ 'crud-linhas-distancia--divergente': !!avisoDistancia('distancia_volta') }"
                :append-icon="avisoDistancia('distancia_volta') ? 'mdi-calculator' : undefined"
                @click:append="usarDistanciaCalculada('distancia_volta')"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select v-model="editedItem.id_tipo_aberturas_viagens" :items="tiposAberturasViagens"
                item-text="descricao_tipo_aberturas_viagens" item-value="id_tipo_aberturas_viagens"
                :label="$t('crudLinhas.form.fields.tripControlType')"
                :rules="[(v) => !!v || $t('crudLinhas.validation.tripControlTypeRequired')]"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.tempo_maximo_permanencia_linha_minutos"
                :label="$t('crudLinhas.form.fields.maxRideTime')" type="number" min="1" suffix="min"
                clearable
                :hint="$t('crudLinhas.form.fields.maxRideTimeHint')" persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.velocidade_media_estimativa_kmh"
                :label="$t('crudLinhas.form.fields.rideTimeAverageSpeed')" type="number" min="1" suffix="km/h"
                clearable
                :hint="$t('crudLinhas.form.fields.rideTimeAverageSpeedHint')" persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template #create-entity>
        <div v-if="creatingCercaNaLinha && cercaNaLinhaRotaId == null" class="pa-2">
          <p class="text-body-2 mb-3">{{ $t('crudLinhas.map.createFenceSelectRouteHint') }}</p>
          <v-select
            :value="cercaNaLinhaRotaId"
            :items="rotasParaCercaNaLinha"
            item-text="_selectLabel"
            item-value="id_rota"
            :label="$t('crudLinhas.map.routeByFencesSelectRoute')"
            dense
            outlined
            clearable
            hide-details="auto"
            class="mb-2"
            :no-data-text="$t('crudLinhas.map.routeByFencesNoRoute')"
            @input="onCercaNaLinhaRotaSelect"
          />
          <div class="d-flex justify-end pt-2">
            <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
              {{ $t('button.cancel') }}
            </v-btn>
          </div>
        </div>
        <v-form v-else-if="!creatingCercaNaLinha" ref="formCreate" v-model="formValidado" class="pa-2">
          <v-checkbox
            v-model="isSublinha"
            :label="$t('crudLinhas.form.fields.sublines')"
            color="primary"
            class="mt-0 mb-2"
            hide-details
            @change="isSublinhaChanged"
          />
          <v-autocomplete
            v-model="linhaPrincipal"
            :items="linhas"
            item-text="nome_linha"
            return-object
            clearable
            dense
            outlined
            :label="$t('crudLinhas.form.fields.selectMainLine')"
            :rules="createValidationAttempted ? [(v) => !!v || !isSublinha || $t('crudLinhas.validation.lineRequired')] : []"
            :disabled="!isSublinha"
            class="mb-2"
            @change="linhaPrincipalChanged"
          />
          <v-text-field
            v-model="editedItem.nome_linha"
            :label="$t('crudLinhas.form.fields.lineName')"
            :rules="createValidationAttempted ? [nomeLinhaRules] : []"
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.lotacao_prevista"
            :label="$t('crudLinhas.form.fields.capacityPerTrip')"
            :rules="createValidationAttempted ? [lotacaoRules] : []"
            dense
            outlined
            class="mb-2"
          />
          <v-textarea
            v-model="editedItem.descricao_linha"
            :label="$t('crudLinhas.form.fields.description')"
            rows="2"
            auto-grow
            clearable
            dense
            outlined
            class="mb-2"
          />
          <v-autocomplete
            v-model="editedItem.id_empresa"
            :items="empresas"
            item-text="razao_social"
            item-value="id_empresa"
            clearable
            dense
            outlined
            :label="$t('crudLinhas.form.fields.selectCompany')"
            :rules="createValidationAttempted ? [(v) => !!v || $t('crudLinhas.validation.companyRequired')] : []"
            :disabled="isScopedClienteCreateLock"
            @change="filtroEmpresaChanged"
          />
          <v-autocomplete
            v-model="editedItem.id_cliente"
            :items="clientesPorEmpresa(editedItem.id_empresa)"
            item-text="nome_cliente"
            item-value="id_cliente"
            clearable
            dense
            outlined
            :label="$t('crudLinhas.form.fields.selectClient')"
            :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
            class="mb-2"
            @change="onClienteChange"
          />
          <v-text-field
            v-model="editedItem.cod_linha"
            :label="$t('crudLinhas.form.fields.lineCode')"
            :rules="createValidationAttempted ? [codLinhaRules] : []"
            dense
            outlined
          />
          <v-text-field
            v-model="editedItem.cod_integracao_linha"
            :label="$t('crudLinhas.form.fields.integrationCode')"
            :rules="createValidationAttempted ? [codIntegracaoLinhaRules] : []"
            clearable
            dense
            outlined
            :hint="$t('crudLinhas.form.fields.integrationCodeHint')"
            persistent-hint
            class="mb-2"
          />
          <v-switch v-model="isCircular" color="primary" class="mt-0 mb-1" hide-details :label="$t('crudLinhas.form.fields.circular')" />
          <v-switch v-model="editedItem.linha_intermunicipal" color="primary" class="mt-0 mb-1" hide-details :label="$t('crudLinhas.form.fields.intermunicipal')" />
          <v-switch v-model="editedItem.has_eta" color="primary" class="mt-0 mb-2" hide-details :label="$t('crudLinhas.form.fields.eta')" />
          <v-text-field
            v-model="velocidadeMaxima"
            :label="$t('crudLinhas.form.fields.maxSpeed')"
            :rules="createValidationAttempted ? [velocidadeMaximaRules] : []"
            dense
            outlined
          />
          <v-switch v-model="alarmeVelocidadeMaxima" class="mt-0 mb-2" hide-details :label="$t('crudLinhas.form.fields.maxSpeedAlarm')" @change="velocidadeMaximaChanged" />
          <v-text-field
            v-model="toleranciaForaRota"
            :label="$t('crudLinhas.form.fields.routeDistanceLimit')"
            type="number"
            min="0"
            dense
            outlined
            :rules="createValidationAttempted ? [(v) => (v === null || v >= 0) || $t('crudLinhas.validation.distanceMustBePositive')] : []"
          />
          <v-switch v-model="alarmeForaRota" color="primary" class="mt-0 mb-1" hide-details :label="$t('crudLinhas.form.fields.outOfRouteAlarm')" />
          <v-switch v-model="isAtiva" color="primary" class="mt-0 mb-2" hide-details :label="$t('crudLinhas.form.fields.active')" />
          <v-text-field
            v-model="limiteTempoParado"
            :label="$t('crudLinhas.form.fields.stoppedTimeLimit')"
            :rules="createValidationAttempted ? [limiteTempoParadoRules] : []"
            type="number"
            dense
            outlined
          />
          <v-switch v-model="alarmeTempoParado" color="primary" class="mt-0 mb-2" hide-details :label="$t('crudLinhas.form.fields.stoppedTimeAlarm')" />
          <v-text-field
            v-model="limiteTempoLargada"
            :label="$t('crudLinhas.form.fields.departureTimeLimit')"
            :rules="createValidationAttempted ? [limiteTempoLargadaRules] : []"
            type="number"
            dense
            outlined
          />
          <v-switch v-model="atualizaInicioViagem" color="primary" class="mt-0 mb-2" hide-details :label="$t('crudLinhas.form.fields.updateTripStart')" />
          <v-text-field
            v-model="editedItem.distancia_ida"
            :label="$t('crudLinhas.form.fields.distanceOutbound')"
            type="number"
            suffix="km"
            dense
            outlined
            :hint="avisoDistancia('distancia_ida')"
            :persistent-hint="!!avisoDistancia('distancia_ida')"
            :class="{ 'crud-linhas-distancia--divergente': !!avisoDistancia('distancia_ida') }"
            :append-icon="avisoDistancia('distancia_ida') ? 'mdi-calculator' : undefined"
            @click:append="usarDistanciaCalculada('distancia_ida')"
          />
          <v-text-field
            v-model="editedItem.distancia_volta"
            :label="$t('crudLinhas.form.fields.distanceReturn')"
            type="number"
            suffix="km"
            dense
            outlined
            class="mb-2"
            :hint="avisoDistancia('distancia_volta')"
            :persistent-hint="!!avisoDistancia('distancia_volta')"
            :class="{ 'crud-linhas-distancia--divergente': !!avisoDistancia('distancia_volta') }"
            :append-icon="avisoDistancia('distancia_volta') ? 'mdi-calculator' : undefined"
            @click:append="usarDistanciaCalculada('distancia_volta')"
          />
          <v-select
            v-model="editedItem.id_tipo_aberturas_viagens"
            :items="tiposAberturasViagens"
            item-text="descricao_tipo_aberturas_viagens"
            item-value="id_tipo_aberturas_viagens"
            :label="$t('crudLinhas.form.fields.tripControlType')"
            :rules="createValidationAttempted ? [(v) => !!v || $t('crudLinhas.validation.tripControlTypeRequired')] : []"
            dense
            outlined
            class="mb-2"
          />
          <v-text-field
            v-model="editedItem.tempo_maximo_permanencia_linha_minutos"
            :label="$t('crudLinhas.form.fields.maxRideTime')"
            type="number"
            min="1"
            suffix="min"
            clearable
            dense
            outlined
            :hint="$t('crudLinhas.form.fields.maxRideTimeHint')"
            persistent-hint
            class="mb-2"
          />
          <v-text-field
            v-model="editedItem.velocidade_media_estimativa_kmh"
            :label="$t('crudLinhas.form.fields.rideTimeAverageSpeed')"
            type="number"
            min="1"
            suffix="km/h"
            clearable
            dense
            outlined
            :hint="$t('crudLinhas.form.fields.rideTimeAverageSpeedHint')"
            persistent-hint
            class="mb-2"
          />
          <v-autocomplete
            ref="unidadesFieldCreate"
            v-model="unidadesLinhaIds"
            :items="unidades"
            item-text="descricao_unidade"
            item-value="id_unidade"
            multiple
            chips
            small-chips
            deletable-chips
            clearable
            dense
            outlined
            :label="$t('crudLinhas.form.fields.selectUnits')"
            :loading="loadingUnidades"
            class="mb-2"
          />
          <v-divider class="my-3" />
          <div class="subtitle-2 mb-2">{{ $t('crudLinhas.form.routes.title') }}</div>
          <LazySelect
            ref="createRotaSelect"
            get-url="getRotaslazy"
            :text="createRotaSelectText"
            value="id_rota"
            :label="$t('crudLinhas.form.routes.route')"
            class="mb-1"
            @select="onCreateRotaSelected"
          />
          <v-select
            v-model="createItemRota.id_tipo_rota"
            :items="tiposRota"
            item-text="descricao_tipo_rota"
            item-value="id_tipo_rota"
            :label="$t('crudLinhas.form.routes.routeType')"
            dense
            outlined
            hide-details="auto"
            class="mb-2"
          />
          <v-select
            v-model="createItemRota.id_sentido"
            :items="sentidos"
            item-text="descricao_sentido"
            item-value="id_sentido"
            :label="$t('crudLinhas.form.routes.direction')"
            dense
            outlined
            hide-details="auto"
            class="mb-2"
          />
          <v-btn color="primary" small block outlined class="mb-2" @click="addCreatePreviewRota">
            {{ $t('button.add') }}
          </v-btn>
          <v-list v-if="createPreviewRotas.length" dense class="mb-2 py-0 create-preview-rotas-list">
            <v-list-item
              v-for="rota in createPreviewRotas"
              :key="'create-rota-' + rota.id_rota + '-' + rota.id_sentido"
              class="px-0"
            >
              <v-list-item-content class="py-1">
                <v-list-item-title class="text-body-2">
                  {{ createRotaSelectText(rota) }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ rota.descricao_tipo_rota || rota.id_tipo_rota }}
                  · {{ rota.descricao_sentido || rota.id_sentido }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  small
                  :aria-label="$t('button.delete')"
                  @click.stop="removeCreatePreviewRota(rota)"
                >
                  <v-icon small color="red">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-divider class="my-3" />
          <div class="subtitle-2 mb-2">{{ $t('crudLinhas.detail.tabs.fences') }}</div>
          <v-select
            v-model="createItemCerca._rotaKey"
            :items="createRotasParaCercaOptions"
            item-text="_selectLabel"
            item-value="_rotaKey"
            :label="$t('crudLinhas.map.routeByFencesSelectRoute')"
            :disabled="!createPreviewRotas.length"
            :no-data-text="$t('crudLinhas.map.routeByFencesNoRoute')"
            dense
            outlined
            hide-details="auto"
            class="mb-2"
          />
          <LazySelect
            ref="createCercaSelect"
            get-url="getCercaslazy"
            :text="createCercaSelectText"
            value="id_cerca"
            :label="$t('crudLinhas.form.fences.fence')"
            :disabled="!createPreviewRotas.length"
            class="mb-1"
            @select="onCreateCercaSelected"
          />
          <v-select
            v-model="createItemCerca.id_tipo_cerca"
            :items="tiposCerca"
            item-text="descricao_tipo_cerca"
            item-value="id_tipo_cerca"
            :label="$t('crudLinhas.form.fences.fenceType')"
            :disabled="!createPreviewRotas.length"
            dense
            outlined
            hide-details="auto"
            class="mb-2"
            @change="createTipoCercaChanged"
          />
          <v-text-field
            v-model.number="createItemCerca.ordem_parada"
            :label="$t('crudLinhas.form.fences.order')"
            type="number"
            min="1"
            :disabled="!createPreviewRotas.length"
            dense
            outlined
            hide-details="auto"
            class="mb-2"
          />
          <v-text-field
            v-model.number="createItemCerca.tempo_chegada_minutos"
            :label="$t('crudLinhas.form.fences.arrival')"
            type="number"
            min="0"
            :disabled="!createPreviewRotas.length"
            dense
            outlined
            hide-details="auto"
            class="mb-2"
          />
          <v-switch
            v-model="createShowSinotico"
            :label="$t('crudLinhas.form.fences.synoptic')"
            :disabled="!createPreviewRotas.length"
            dense
            hide-details
            class="mt-0 mb-2"
          />
          <v-btn
            color="primary"
            small
            block
            outlined
            class="mb-2"
            :disabled="!createPreviewRotas.length"
            @click="addCreatePreviewCerca"
          >
            {{ $t('button.add') }}
          </v-btn>
          <template v-for="rotaOpt in createRotasParaCercaOptions">
            <div
              v-if="createCercasPorRota(rotaOpt._rotaKey).length"
              :key="'create-cerca-group-' + rotaOpt._rotaKey"
              class="mb-2"
            >
              <div class="text-caption grey--text text--darken-1">
                {{ rotaOpt._selectLabel }}
              </div>
              <v-list dense class="py-0 create-preview-cercas-list">
                <v-list-item
                  v-for="cerca in createCercasPorRota(rotaOpt._rotaKey)"
                  :key="'create-cerca-' + cerca.id_cerca + '-' + cerca.id_sentido"
                  class="px-0"
                >
                  <v-list-item-content class="py-1">
                    <v-list-item-title class="text-body-2">
                      {{ cerca.nome_cerca || cerca.cod_cerca || cerca.id_cerca }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption">
                      {{ cerca.descricao_tipo_cerca || cerca.id_tipo_cerca }}
                      · {{ $t('crudLinhas.form.fences.order') }}: {{ cerca.ordem_parada != null ? cerca.ordem_parada : '—' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      :aria-label="$t('button.delete')"
                      @click.stop="removeCreatePreviewCerca(cerca)"
                    >
                      <v-icon small color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </template>
          <div class="d-flex justify-end pt-2">
            <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
              {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary darken-1" class="white--text" small @click="save">
              {{ $t('button.save') }}
            </v-btn>
          </div>
        </v-form>
        <v-form v-else ref="formCreateCerca" v-model="formValidadoCerca" class="pa-2">
          <v-text-field
            v-model="novaCercaItem.cod_cerca"
            :label="$t('geofence.code')"
            :rules="[novaCercaCodRules]"
            dense
            outlined
          />
          <v-text-field
            v-model="novaCercaItem.nome_cerca"
            :label="$t('geofence.name')"
            :rules="[novaCercaNomeRules]"
            dense
            outlined
          />
          <v-text-field
            v-model="novaCercaItem.cod_integracao"
            :label="$t('geofence.integrationCode')"
            :rules="[novaCercaCodIntegracaoRules]"
            maxlength="50"
            clearable
            dense
            outlined
          />
          <v-switch v-model="novaCercaItem.ativa" class="mt-0 mb-2" hide-details :label="$t('geofence.active')" />
          <v-autocomplete
            v-model="novaCercaItem.id_empresa"
            :items="empresas"
            item-text="razao_social"
            item-value="id_empresa"
            clearable
            dense
            outlined
            :label="$t('area.selectCompany')"
          />
          <v-autocomplete
            v-model="novaCercaItem.id_cliente"
            :items="clientesPorEmpresa(novaCercaItem.id_empresa)"
            item-text="nome_cliente"
            item-value="id_cliente"
            clearable
            dense
            outlined
            :disabled="!novaCercaItem.id_empresa"
            :label="$t('geofence.selectClient')"
            class="mb-2"
          />
          <div class="caption grey--text mb-1">{{ $t('geofence.format') }}</div>
          <v-radio-group
            v-model="novaCercaItem.is_circular"
            row
            dense
            class="mt-0 mb-2"
            hide-details="auto"
            :rules="[novaCercaFormatoRules]"
            @change="novaCercaCircularChanged"
          >
            <v-radio :label="$t('geofence.formatCircular')" :value="1" />
            <v-radio :label="$t('geofence.formatPolygon')" :value="0" />
          </v-radio-group>
          <v-text-field
            v-model="novaCercaItem.raio_mts"
            :label="$t('geofence.radius')"
            type="number"
            min="1"
            suffix="m"
            hide-spin-buttons
            dense
            outlined
            :disabled="novaCercaItem.is_circular == 0"
            :rules="[novaCercaRaioRules]"
            class="mb-2"
          />
          <div class="d-flex align-center mb-2">
            <v-text-field
              v-model="novaCercaItem.lat_centro"
              :label="$t('geofence.latitude')"
              dense
              outlined
              hide-details="auto"
              class="flex-grow-1 mr-2"
              @change="novaCercaGetMarkerFromLatLong"
            />
            <v-text-field
              v-model="novaCercaItem.lng_centro"
              :label="$t('geofence.longitude')"
              dense
              outlined
              hide-details="auto"
              class="flex-grow-1"
              @change="novaCercaGetMarkerFromLatLong"
            />
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  fab
                  x-small
                  dark
                  class="ml-2"
                  :color="pickLocationAtivoCerca ? 'warning' : 'primary'"
                  @click="toggleNovaCercaPickLocation"
                >
                  <v-icon small>mdi-map-marker-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('geofence.pickOnMap') }}</span>
            </v-tooltip>
          </div>
          <div v-if="novaCercaItem.is_circular != 1" class="mb-3">
            <div class="d-flex align-center flex-wrap mb-1">
              <v-btn
                small
                class="mr-2 mb-1"
                :color="desenhoPoligonoAtivoCerca ? 'warning' : 'primary'"
                dark
                @click="toggleNovaCercaDesenhoPoligono"
              >
                <v-icon left small>mdi-vector-polygon</v-icon>
                {{ $t('crudLinhas.map.controls.drawPolygon') }}
              </v-btn>
              <v-chip
                v-if="novaCercaContagemVertices > 0"
                x-small
                class="mr-2 mb-1"
                color="primary"
                text-color="white"
              >
                {{ $t('geofence.polygonDefined', { count: novaCercaContagemVertices }) }}
              </v-chip>
              <v-btn
                v-if="novaCercaContagemVertices > 0"
                x-small
                text
                class="mb-1"
                @click="limparPoligonoNovaCerca"
              >
                {{ $t('button.clear') }}
              </v-btn>
            </div>
          </div>
          <v-switch v-model="novaCercaAlarmeEntrada" class="mt-0 mb-1" hide-details :label="$t('geofence.entranceAlarm')" />
          <v-switch v-model="novaCercaAlarmeSaida" class="mt-0 mb-1" hide-details :label="$t('geofence.exitAlarm')" />
          <v-switch v-model="novaCercaAlarmeVelocidade" class="mt-0 mb-2" hide-details :label="$t('system.labels.speed')" />
          <v-text-field
            v-model="novaCercaItem.velocidade_maxima"
            :label="$t('geofence.maxSpeed')"
            type="number"
            min="1"
            hide-spin-buttons
            dense
            outlined
            :rules="[novaCercaVelocidadeRules]"
            class="mb-2"
          />
          <div class="d-flex align-center mb-2">
            <v-text-field
              v-model="novaCercaItem.endereco"
              :label="$tc('address.self', 1)"
              counter="300"
              clearable
              dense
              outlined
              hide-details="auto"
              prepend-icon="mdi-map-marker"
              :rules="[(v) => (v === null || v.length <= 300) || $t('geofence.addressCharacterLimit')]"
              class="flex-grow-1"
            />
            <v-btn fab color="primary" dark x-small class="ml-2" @click="novaCercaGetMarkerFromEndereco" :loading="loadingEnderecoCerca">
              <v-icon small>mdi-map-search</v-icon>
            </v-btn>
          </div>
          <v-textarea
            clearable
            clear-icon="mdi-close-circle"
            v-model="novaCercaItem.observacoes"
            :label="$tc('system.labels.observation', 2)"
            :rules="[novaCercaObservacoesRules]"
            dense
            outlined
            class="mb-2"
          />
          <div class="d-flex justify-end pt-2">
            <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
              {{ $t('button.cancel') }}
            </v-btn>
            <v-btn color="primary darken-1" class="white--text" small :loading="savingNovaCerca" @click="saveNovaCercaNaLinha">
              {{ $t('button.save') }}
            </v-btn>
          </div>
        </v-form>
      </template>
    <merus-data-table 
      :headers="headers" 
      :items="linhas" 
      mostrar-inativos
      :loading="loadingtable"
      :loading-text="$t('crudLinhas.loading')" 
      :default-multi-sort="defaultSort"
      :server-items-length="totalLinhas"
      :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy"
      :server-sort-desc="serverSortDesc"
      @update:options="onTableOptions"
      @update:filters="onFiltersUpdate"
      item-key="id_linha"
      show-select
      v-model="selecionadas"
      cod-tabela="LINHAS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('crudLinhas.title')"
          :token="token"
          :items="[]"
          :load-items-for-export="loadItemsForExport"
          background-export
          :export-filters="searchFilters"
          :export-sort-by="serverSortBy"
          :export-sort-desc="serverSortDesc"
          :export-total="totalLinhas"
          :selected-ids="selectedLinhasIds"
          id-field="id_linha"
          :csv-title="$t('crudLinhas.title')"
          :pdf-title="$t('crudLinhas.title')"
          :pdf-headers="headers"
          pdf-filename="linhas"
          csv-filename="linhas"
          :csv-headers="headersCSVLinhas"
          hide-search
        >
          <template v-slot:extension>
              <v-col cols="12" sm="12" md="12">
                <v-switch
                  v-model="mostrarInativos"
                  :label="$t('crudVeiculos.showInactive')"
                  class="ml-3 mr-4"
                  hide-details
                ></v-switch>
              </v-col>
          </template>
          <template v-slot:add>
            <v-tooltip v-if="canInsert" top>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark small class="mb-2 mr-2" fab v-on="on" @click="startCreateLinha">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('crudLinhas.register') }}</span>
            </v-tooltip>
            <v-tooltip v-if="canInsert" top>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark small class="mb-2 mr-2" fab v-on="on" @click="dialogAssistenteKml = true">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('crudLinhas.wizard.assistantTooltip') }}</span>
            </v-tooltip>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.taxa_ocupacao="{ item }">
        {{ item.taxa_ocupacao !== null ? `${item.taxa_ocupacao} %` : null }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="red" @click.stop="deleteItem(item)" :disabled="item.ativa === 0 || !canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>
    </recursos-operacionais-split-layout>

    <linha-assistente-dialog v-model="dialogAssistenteKml" @saved="onAssistenteKmlSaved" />
  </v-container>
</template>

<script>

import axios from "axios";
import apiController from "@/utils/apiController";
import { validador, GeoCodeApiKey, GeoCodeBaseUrl } from "@/constants";
import EventBus from '../utils/eventBus';
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import translateDbField from "@/utils/translateDbField";
import LinhaAssistenteDialog from "./Dialogs/LinhaAssistenteDialog.vue";
import RecursosOperacionaisSplitLayout from "./Linhas/RecursosOperacionaisSplitLayout.vue";
import LazySelect from "./Selects/LazySelect.vue";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";
import { resolveHistoricoRoteirizacaoCrudSession } from "@/utils/historicoRoteirizacaoSnapshot";
import { hasTerminusOrderViolation, wouldBreakTerminusOrder } from "@/utils/allocationFenceCreation";
import { sameSelection, mergeSelectionWithPage, dropFromSelection, currentPageItem } from "@/utils/tableSelection";
import serverTableMixin from "@/mixins/serverTableMixin";
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    LinhaAssistenteDialog,
    RecursosOperacionaisSplitLayout,
    LazySelect,
  },
  mixins: [serverTableMixin],
  data: () => ({
    headers: [],
    headersRotas: [],
    headersCercas: [],
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    showAlertLinha: false,
    mensagemAlertaLinha: "",
    tipoAlertaLinha: "success",
    loadingsublinhas: false,
    editingSublinha: false,
    loadingcercas: false,
    dialogCercas: false,
    disableInsertCerca: false,
    loadingrotas: false,
    dialogRotas: false,
    disableInsertRota: false,
    totalLinhas: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    mostrarInativos: false,
    displayedCercasItemsForExport: null,
    displayedRotasItemsForExport: null,
    linhaSelecionada: null,
    selecionadas: [],
    parametrosPage: 0,
    pendingSelectIdLinha: null,
    pendingPublishedLineIds: [],
    publishedRouteIds: [],
    historicoSessaoId: null,
    historicoSessaoOrigemId: null,
    pendingEditIdLinha: null,
    pendingFocusSecao: null,
    highlightUnidadesField: false,
    highlightUnidadesTimer: null,
    lineRecencyById: {},
    initialDetailTabKey: null,
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    formValidadoCercas: true,
    formValidadoRotas: true,
    dialog: false,
    dialogAssistenteKml: false,
    creatingLinha: false,
    /** Linha ativa antes de iniciar o cadastro de uma nova ÔÇö mostrada como pano de fundo. */
    linhaAntesDeCriar: null,
    createValidationAttempted: false,
    createPreviewRotas: [],
    createPreviewCerca: null,
    createPreviewCercasLinha: [],
    createPreviewPreferUnidade: false,
    createItemCerca: {
      id_cerca: null,
      nome_cerca: null,
      id_tipo_cerca: null,
      show_sinotico: 1,
      tempo_chegada_minutos: 0,
      /** Rota do preview a que a cerca pertence; define o id_sentido gravado. */
      id_rota: null,
      _rotaKey: null,
      id_sentido: null,
      ordem_parada: 1,
    },
    createShowSinotico: true,
    createCercaSelectedDetail: null,
    /** Rota em montagem no drawer: só entra no preview com tipo e sentido. */
    createItemRota: {
      id_rota: null,
      id_tipo_rota: null,
      id_sentido: null,
    },
    createRotaSelectedDetail: null,
    /** Cria├º├úo de cerca nova associada ├á linha ativa, via FAB do mapa. */
    creatingCercaNaLinha: false,
    /** Rota escolhida antes de cadastrar cerca na linha (select ou clique no mapa). */
    cercaNaLinhaRotaId: null,
    formValidadoCerca: true,
    savingNovaCerca: false,
    loadingEnderecoCerca: false,
    pickLocationAtivoCerca: false,
    desenhoPoligonoAtivoCerca: false,
    novaCercaAlarmeEntrada: false,
    novaCercaAlarmeSaida: false,
    novaCercaAlarmeVelocidade: false,
    novaCercaItem: {
      cod_cerca: null,
      nome_cerca: null,
      cod_integracao: null,
      shape: null,
      geojson: null,
      ativa: true,
      endereco: null,
      lat_centro: null,
      lng_centro: null,
      alarme_velocidade: null,
      velocidade_maxima: null,
      is_circular: null,
      raio_mts: null,
      id_empresa: null,
      id_cliente: null,
      observacoes: null,
    },
    /** Snapshot dos ids de unidade antes do ├║ltimo change (para detectar a rec├®m-adicionada). */
    createUnidadesIdsPrev: [],
    operacao: 0,
    isAtiva: true,
    isCircular: false,
    velocidadeMaxima: 0,
    limiteTempoParado: 0,
    alarmeTempoParado: false,
    alarmeForaRota: false,
    alarmeVelocidadeMaxima: false,
    confirmDialog: false,
    dialogTerminusOrder: false,
    confirmDialogType: 'delete',
    lastConfirmedIdCliente: null,
    pendingIdCliente: null,
    suppressClienteConfirmChange: false,
    mensagemdialog: "",
    disableModelo: true,
    loadingtable: true,
    loadingparadas: false,
    alarmeTrecho: false,
    timeProps: {
      useSeconds: false,
    },
    cercas: [],
    cercasLinha: [],
    tiposCerca: [],
    cercasValidado: false,
    rotasLinha: [],
    tiposRota: [],
    rotasValidado: false,
    empresas: [],
    clientes: [],
    rotas: [],
    filteredRotas: [],
    linhas: [],
    paradas: [],
    frequencia: [],
    associacoes: [],
    sentidos: [],
    tiposAberturasViagens: [],
    unidades: [],
    unidadesLinhaIds: [],
    loadingUnidades: false,
    editedIndex: -1,
    editingParada: false,
    editingCerca: false,
    editingCercaOriginal: null,
    editingRota: false,
    editingTrecho: false,
    disableInsertParada: false,
    linhaSelected: null,
    inicio_vigencia: null,
    fim_vigencia: null,
    showSinotico: null,
    limiteTempoLargada: null,
    atualizaInicioViagem: null,
    toleranciaForaRota: null,
    itemCercas: {
      id_cerca: null,
      nome_cerca: null,
      id_tipo_cerca: null,
      descricao_tipo_cerca: null,
      cod_tipo_cerca: null,
      show_sinotico: null,
      show_sinotico_extenso: null,
      tempo_chegada_minutos: null,
      id_sentido: null,
      descricao_sentido: null,
      ordem_parada: null,
    },
    defaultItemCercas: {
      id_cerca: null,
      nome_cerca: null,
      id_tipo_cerca: null,
      descricao_tipo_cerca: null,
      cod_tipo_cerca: null,
      show_sinotico: null,
      show_sinotico_extenso: null,
      tempo_chegada_minutos: null,
      id_sentido: null,
      descricao_sentido: null,
      ordem_parada: null,
    },
    itemRotas: {
      id_rota: null,
      nome_rota: null,
      id_tipo_rota: 1,
      descricao_tipo_rota: null,
      id_sentido: null,
      descricao_sentido: null,
      shape: null,
    },
    defaultItemRotas: {
      id_rota: null,
      nome_rota: null,
      id_tipo_rota: 1,
      descricao_tipo_rota: null,
      id_sentido: null,
      descricao_sentido: null,
    },
    editedItem: {
      id_linha: null,
      id_empresa: null,
      razao_social: null,
      nome_linha: null,
      descricao_linha: null,
      quadro_ativo: null,
      data_associacao: null,
      cod_linha: null,
      ativa: null,
      ativa_extenso: null,
      id_rota: null,
      nome_rota: null,
      shape: null,
      velocidade_maxima: null,
      alarme_velocidade_maxima: null,
      tolerancia_fora_rota: null,
      alarme_fora_rota: null,
      circular: null,
      circular_extenso: null,
      distancia_ida: null,
      distancia_volta: null,
      limite_tempo_parado: null,
      alarme_tempo_parado: null,
      tempo_maximo_largada: null,
      atualiza_inicio_viagem: null,
      id_linha_principal: null,
      sublinhas: [],
      linha_intermunicipal: null,
      lotacao_prevista: null,
      has_eta: null,
      eta_extenso: null,
      id_tipo_aberturas_viagens: null,
      cod_tipo_aberturas_viagens: null,
      descricao_tipo_aberturas_viagens: null,
      tempo_maximo_permanencia_linha_minutos: null,
      velocidade_media_estimativa_kmh: null,
      cod_integracao_prodata_tz: null,
      cod_integracao_linha: null,
      id_cliente: null,
      nome_cliente: null,
    },
    deletedItem: {
      id_linha: null,
      id_empresa: null,
      razao_social: null,
      nome_linha: null,
      descricao_linha: null,
      quadro_ativo: null,
      data_associacao: null,
      cod_linha: null,
      ativa: null,
      ativa_extenso: null,
      id_rota: null,
      nome_rota: null,
      shape: null,
      velocidade_maxima: null,
      alarme_velocidade_maxima: null,
      alarme_fora_rota: null,
      tolerancia_fora_rota: null,
      circular: null,
      circular_extenso: null,
      distancia_ida: null,
      distancia_volta: null,
      limite_tempo_parado: null,
      alarme_tempo_parado: null,
      tempo_maximo_largada: null,
      atualiza_inicio_viagem: null,
      id_linha_principal: null,
      sublinhas: [],
      linha_intermunicipal: null,
      lotacao_prevista: null,
      has_eta: null,
      eta_extenso: null,
      id_tipo_aberturas_viagens: null,
      cod_tipo_aberturas_viagens: null,
      descricao_tipo_aberturas_viagens: null,
      tempo_maximo_permanencia_linha_minutos: null,
      velocidade_media_estimativa_kmh: null,
      cod_integracao_prodata_tz: null,
      cod_integracao_linha: null,
      id_cliente: null,
      nome_cliente: null,
    },
    defaultItem: {
      id_linha: null,
      id_empresa: null,
      razao_social: null,
      nome_linha: null,
      descricao_linha: null,
      quadro_ativo: null,
      data_associacao: null,
      cod_linha: null,
      ativa: null,
      ativa_extenso: null,
      id_rota: null,
      nome_rota: null,
      shape: null,
      endereco_ponto_final: null,
      velocidade_maxima: null,
      alarme_velocidade_maxima: null,
      tolerancia_fora_rota: null,
      alarme_fora_rota: null,
      circular: null,
      circular_extenso: null,
      distancia_ida: null,
      distancia_volta: null,
      limite_tempo_parado: null,
      alarme_tempo_parado: null,
      tempo_maximo_largada: null,
      atualiza_inicio_viagem: null,
      id_linha_principal: null,
      sublinhas: [],
      linha_intermunicipal: null,
      lotacao_prevista: null,
      has_eta: null,
      eta_extenso: null,
      id_tipo_aberturas_viagens: null,
      cod_tipo_aberturas_viagens: null,
      descricao_tipo_aberturas_viagens: null,
      tempo_maximo_permanencia_linha_minutos: null,
      velocidade_media_estimativa_kmh: null,
      cod_integracao_prodata_tz: null,
      cod_integracao_linha: null,
      id_cliente: null,
      nome_cliente: null,
    },
    limitesTrecho: {
      id_trecho: null,
      horario_inicio: null,
      horario_fim: null,
      tempo_minimo: null,
      tempo_maximo: null,
    },
    defaultLimitesTrecho: {
      id_trecho: null,
      horario_inicio: null,
      horario_fim: null,
      tempo_minimo: null,
      tempo_maximo: null,
    },
    loadingInsertCercas: false,
    loadingInsertRotas: false,
    tab: 0,
    formValidadoSublinhas: false,
    sublinhas: [],
    sublinha: null,
    disableInsertSublinha: false,
    isSublinha: false,
    linhaPrincipal: null,
    editedCercas: false,
    editedRotas: false,
    editedParadas: false,
    editedSublinhas: false,
    recursos: [],
    empresasPermitidas: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    scopedClienteCreateLocked: false,
  }),
  computed: {
    /** Linha exibida na p├ígina atual do paginador de par├ómetros. */
    itemParametrosAtual() {
      return currentPageItem(this.selecionadas, this.parametrosPage);
    },
    /** Demais linhas marcadas na tabela (al├®m da exibida/edit├ível no mapa), para sobreposi├º├úo. */
    outrasLinhasSelecionadas() {
      const atual = this.linhaSelecionada && this.linhaSelecionada.id_linha;
      return (this.selecionadas || []).filter(
        (l) => l && l.id_linha != null && String(l.id_linha) !== String(atual)
      );
    },
    /**
     * Pano de fundo do mapa ao cadastrar uma linha nova: linhas marcadas na tabela +
     * a que estava ativa antes de clicar em "cadastrar" (para o mapa n├úo esvaziar).
     */
    createBackdropLinhas() {
      const checked = this.selecionadas || [];
      const prev = this.linhaAntesDeCriar;
      if (!prev || prev.id_linha == null) return checked;
      const already = checked.some((l) => l && String(l.id_linha) === String(prev.id_linha));
      return already ? checked : [prev, ...checked];
    },
    /**
     * Rotas desenhadas no mapa durante o cadastro: as já adicionadas mais a que está
     * selecionada no LazySelect e ainda não foi adicionada, para o usuário conferir
     * o traçado antes de confirmar.
     */
    createPreviewRotasNoMapa() {
      const rotas = this.createPreviewRotas || [];
      const pendente = this.createRotaSelectedDetail;
      if (!pendente || pendente.id_rota == null) return rotas;
      const jaNoMapa = rotas.some((r) => Number(r.id_rota) === Number(pendente.id_rota));
      return jaNoMapa ? rotas : [...rotas, pendente];
    },
    /**
     * Cercas desenhadas no mapa durante o cadastro: as já adicionadas mais a que está
     * selecionada no LazySelect e ainda não foi adicionada. O mapa resolve a geometria
     * pelo id_cerca (ensureCercaDetail), então basta o item do select.
     */
    createPreviewCercasNoMapa() {
      const cercas = this.createPreviewCercasLinha || [];
      const pendente = this.createCercaSelectedDetail;
      if (!pendente || pendente.id_cerca == null) return cercas;
      const jaNoMapa = cercas.some((c) => Number(c.id_cerca) === Number(pendente.id_cerca));
      return jaNoMapa ? cercas : [...cercas, pendente];
    },
    /** Rotas já adicionadas no drawer, como opções do select de rota da cerca. */
    createRotasParaCercaOptions() {
      return (this.createPreviewRotas || []).map((r) => ({
        ...r,
        _rotaKey: this.createRotaKey(r),
        _selectLabel: [this.createRotaSelectText(r), r.descricao_sentido]
          .filter(Boolean)
          .join(" · "),
      }));
    },
    rotasParaCercaNaLinha() {
      return (this.rotasLinha || [])
        .filter((r) => r && r.id_rota != null)
        .map((r) => ({
          ...r,
          _selectLabel: this.createRotaSelectText(r),
        }));
    },
    parametrosLabel() {
      const item = this.itemParametrosAtual;
      if (!item) return null;
      return [item.cod_linha, item.nome_linha].filter(Boolean).join(" ÔÇö ") || null;
    },
    selectedLinhasIds() {
      return (this.selecionadas || [])
        .map((l) => (l && l.id_linha != null ? l.id_linha : null))
        .filter((id) => id != null);
    },
    headersCSVLinhas() {
      return (this.headers || [])
        .filter((h) => h && h.value && h.value !== 'actions' && h.value !== '_recencySort')
        .map((h) => ({ text: h.text, value: h.value }));
    },
    messageConfirmButton() { return this.$t('button.confirm')},
    messageDismissButton() { return this.$t('button.dismiss')},
    textFieldProps() {
      return {
      prependInnerIcon: "mdi-calendar",
      rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data in├¡cio deve ser menor que data fim !"]
      };
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('crudLinhas.form.title.create') : this.$t('crudLinhas.form.title.edit');
    },
    isScopedClienteCreateLock() {
      return this.editedIndex === -1 && this.scopedClienteCreateLocked;
    },
    formTitleParada() {
      return this.editingParada === false ? this.$t('crudLinhas.form.title.createStop') : this.$t('crudLinhas.form.title.editStop');
    },
    /** Distâncias (km) calculadas pelas rotas da linha em edição. */
    distanciasCalculadas() {
      const circular = this.isCircular != null ? this.isCircular : this.editedItem && this.editedItem.circular;
      return this.calculaDistanciasFromRotas(this.rotasLinha, circular);
    },
    formTitleCerca() {
      return this.editingCerca === false ? this.$t('crudLinhas.form.title.createGeofence') : this.$t('crudLinhas.form.title.editGeofence');
    },
    formTitleRota() {
      return this.editingCerca === false ? this.$t('crudLinhas.form.title.createRoute') : this.$t('crudLinhas.form.title.editRoute');
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    lotacaoRules() {
      if (this.editedItem.lotacao_prevista) {
        if (this.editedItem.lotacao_prevista <= 0) {
          return this.$t('crudLinhas.validation.mustBeGreaterThanZero');
        }
      }

      return true;
    },
    velocidadeMaximaRules() {
      if (this.velocidadeMaxima == null) {
        return this.$t('crudLinhas.validation.maxSpeedRequired');
      } else {
        if (this.velocidadeMaxima.length === 0) {
          return this.$t('crudLinhas.validation.maxSpeedRequired');
        } else {
          if (this.alarmeVelocidadeMaxima == true && this.velocidadeMaxima < 1) {
            return this.$t('crudLinhas.validation.maxSpeedMustBeGreaterThanZero');
          } else {
            return true;
          }
        }
      }
    },
    limiteTempoParadoRules() {
      if (this.limiteTempoParado === null) {
        return true;
      } else {
        if (this.limiteTempoParado.length === 0) {
          return this.$t('crudLinhas.validation.stoppedTimeLimitRequired');
        } else {
          if (this.alarmeTempoParado == true && this.limiteTempoParado < 1) {
            return this.$t('crudLinhas.validation.stoppedTimeLimitMustBeGreaterThanZero');
          } else {
            return true;
          }
        }
      }
    },
    limiteTempoLargadaRules() {
      if (!this.atualizaInicioViagem) {
        return true;
      }

      if (this.atualizaInicioViagem && (this.limiteTempoLargada === null || this.limiteTempoLargada.length === 0)) {
        return this.$t('crudLinhas.validation.departureTimeLimitRequired');
      }

      if (this.limiteTempoLargada === null || this.limiteTempoLargada.length === 0) {
        return true;
      } else {
        if (this.limiteTempoLargada < 1) {
          return this.$t('crudLinhas.validation.departureTimeLimitMustBeGreaterThanZero');
        } else {
          return true;
        }
      }
    },
    codIntegracaoLinhaRules() {
      const valor = this.editedItem.cod_integracao_linha;
      if (valor === null || valor === undefined || String(valor).length === 0) {
        return true;
      }
      if (!validador(valor, 1, 30, 0, 1)) {
        return this.$t('crudLinhas.validation.integrationCodeInvalid');
      }
      return true;
    },
    codLinhaRules() {
      if (!validador(this.editedItem.cod_linha, 1, 50, 0, 1)) {
        return this.$t('crudLinhas.validation.lineCodeRequired');
      } else {
        return true;
      }
    },
    nomeLinhaRules() {
      if (!validador(this.editedItem.nome_linha, 1, 100, 2, 1)) {
        return this.$t('crudLinhas.validation.lineNameRequired');
      } else {
        return true;
      }
    },
    novaCercaCodRules() {
      if (!validador(this.novaCercaItem.cod_cerca, 1, 50, 0, 1)) {
        return this.$t('geofence.invalidCode');
      }
      return true;
    },
    novaCercaNomeRules() {
      if (!validador(this.novaCercaItem.nome_cerca, 1, 200, 1, 1)) {
        return this.$t('geofence.invalidName');
      }
      return true;
    },
    novaCercaCodIntegracaoRules() {
      const valor = this.novaCercaItem.cod_integracao;
      if (valor === null || valor === undefined || String(valor).length === 0) {
        return true;
      }
      if (!validador(valor, 1, 50, 0, 1)) {
        return this.$t('geofence.invalidIntegrationCode');
      }
      return true;
    },
    novaCercaRaioRules() {
      if (this.novaCercaItem.is_circular == 1) {
        if (this.novaCercaItem.raio_mts == null) {
          return this.$t('geofence.radiusRequired');
        }
        if (this.novaCercaItem.raio_mts <= 0) {
          return this.$t('geofence.radiusMustBeGreaterThanZero');
        }
      }
      return true;
    },
    novaCercaFormatoRules() {
      if (this.novaCercaItem.is_circular == null || this.novaCercaItem.is_circular === "") {
        return this.$t("geofence.formatRequired");
      }
      return true;
    },
    novaCercaVelocidadeRules() {
      if (this.novaCercaAlarmeVelocidade && !this.novaCercaItem.velocidade_maxima) {
        return this.$t('geofence.invalidSpeed');
      }
      return true;
    },
    novaCercaObservacoesRules() {
      return (
        this.novaCercaItem.observacoes === null ||
        this.novaCercaItem.observacoes.length <= 1000
      ) || this.$t('geofence.invalidObservations');
    },
    /** Contagem de v├®rtices do pol├¡gono em desenho, para o chip informativo do drawer. */
    novaCercaContagemVertices() {
      const shape = this.novaCercaItem && this.novaCercaItem.shape;
      if (!shape) return 0;
      try {
        const arr = typeof shape === "string" ? JSON.parse(shape) : shape;
        if (!Array.isArray(arr) || !arr.length) return 0;
        let n = arr.length;
        if (n >= 2) {
          const a = arr[0];
          const b = arr[n - 1];
          const aLat = a && (a.lt != null ? a.lt : a.lat);
          const aLng = a && (a.lg != null ? a.lg : a.lng);
          const bLat = b && (b.lt != null ? b.lt : b.lat);
          const bLng = b && (b.lg != null ? b.lg : b.lng);
          if (Number(aLat) === Number(bLat) && Number(aLng) === Number(bLng)) n -= 1;
        }
        return Math.max(0, n);
      } catch (e) {
        return 0;
      }
    },
    defaultSort() {
      return [
        { value: '_recencySort', options: { text: this.$t('system.labels.decreasing'), value: -1 } },
        { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
    },
    headersSublinhas() {
      return [
        { text: this.$t('crudLinhas.headers.sublines.idSublines'), value: "id_linha", align: " d-none" },
        { text: this.$t('crudLinhas.headers.sublines.code'), value: "cod_linha" },
        { text: this.$t('crudLinhas.headers.sublines.name'), value: "nome_linha" },
        { text: this.$t('crudLinhas.headers.sublines.actions'), value: "actions", sortable: false },
      ];
    },
    defaultMultiSortCercas() {
      return [
        { value: 'ordem_parada', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        { value: 'id_tipo_cerca', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
    defaultMultiSortRotas() {
      return [
        { value: 'cod_rota', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    selecionadas(list, prev) {
      // MerusDataTable emite `input` duas vezes por mudan├ºa: compara por chave.
      if (sameSelection(list, prev, "id_linha")) return;
      this.parametrosPage = 0;
    },
    itemParametrosAtual(item, prev) {
      const atual = item && item.id_linha;
      const anterior = prev && prev.id_linha;
      if (String(atual) === String(anterior)) return;
      // Paginar em Par├ómetros n├úo deve pular para a aba Mapa.
      this.selecionarLinha(item || null, { manterAba: true });
    },
    mostrarInativos() {
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    unidadesLinhaIds(ids) {
      if (!this.creatingLinha) return;
      this.onCreateUnidadesChange(ids);
    },
    linhaSelecionada(item, prev) {
      if (item && item.id_linha != null) {
        this.editedIndex = 0;
        this.preencheLinha(item);
      } else if (prev && !this.creatingLinha) {
        this.closeParametros();
      }
      if (item && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
      if (item && this.pendingFocusSecao === "unidades") {
        this.$nextTick(() => this.highlightSecaoUnidades());
      } else if (!item) {
        this.clearHighlightUnidades();
      }
    },
    clientes() {
      if (this.linhaSelecionada && this.editedIndex === -1) {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
      }
    },
    empresas() {
      if (this.linhaSelecionada && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.formParametros) {
        this.$refs.formParametros.resetValidation();
      }
      if (this.$refs.formRotas) {
        this.$refs.formRotas.resetValidation();
      }
      if (this.$refs.formCercas) {
        this.$refs.formCercas.resetValidation();
      }
    },
    '$route.query': {
      deep: true,
      handler(query, prev) {
        const nextEdit = query && query.acao === 'editar' ? String(query.id_linha || '') : '';
        const prevEdit = prev && prev.acao === 'editar' ? String(prev.id_linha || '') : '';
        const nextSecao = query && query.secao ? String(query.secao) : '';
        const prevSecao = prev && prev.secao ? String(prev.secao) : '';
        if (nextEdit === prevEdit && nextSecao === prevSecao) return;
        if (!nextEdit && !nextSecao && !(query && query.linhasPublicadas)) return;
        this.preparePublishedLinesNavigation();
        if (this.linhas && this.linhas.length) {
          this.openPendingEditLinha();
        }
      },
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.preparePublishedLinesNavigation();
    this.initialize();
  },
  mounted() {
    if (sessionStorage.getItem('openLinhaAssistenteKml') === '1') {
      sessionStorage.removeItem('openLinhaAssistenteKml');
      this.dialogAssistenteKml = true;
    }
  },
  methods: {

    preparePublishedLinesNavigation() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      const raw = query.linhasPublicadas;
      this.pendingPublishedLineIds = String(raw || '')
        .split(',')
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      const routesRaw = query.rotasPublicadas;
      this.publishedRouteIds = String(routesRaw || '')
        .split(',')
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      const sessionRaw = Array.isArray(query.historicoSessao)
        ? query.historicoSessao[0]
        : query.historicoSessao;
      this.historicoSessaoOrigemId = sessionRaw != null && String(sessionRaw).trim()
        ? String(sessionRaw).trim().slice(0, 36)
        : null;
      this.historicoSessaoId = null;
      this.resolveHistoricoSessaoCrud();
      const aba = query.aba;
      if (aba === 'rotas') this.initialDetailTabKey = 'routes';
      else if (aba === 'cercas') this.initialDetailTabKey = 'fences';
      else if (aba === 'turnos') this.initialDetailTabKey = 'shifts';
      else this.initialDetailTabKey = null;

      const editId = Number(query.id_linha);
      if (query.acao === 'editar' && Number.isFinite(editId) && editId > 0) {
        this.pendingEditIdLinha = editId;
        if (!this.pendingPublishedLineIds.includes(editId)) {
          this.pendingPublishedLineIds = [editId, ...this.pendingPublishedLineIds];
        }
      }
      const secaoRaw = Array.isArray(query.secao) ? query.secao[0] : query.secao;
      let secao = secaoRaw != null ? String(secaoRaw) : '';
      const secoesValidas = ['unidades', 'turnos'];
      if (!secoesValidas.includes(secao)) {
        try {
          const storedSecao = sessionStorage.getItem('linhasHighlightSecao');
          const storedId = sessionStorage.getItem('linhasHighlightId');
          if (secoesValidas.includes(storedSecao)
            && (storedId == null || !editId || String(storedId) === String(editId))) {
            secao = storedSecao;
          }
        } catch (e) { /* ignore */ }
      }
      this.pendingFocusSecao = secoesValidas.includes(secao) ? secao : null;
    },

    onAssistenteKmlSaved() {
      this.loadingtable = true;
      this.populaLinhas();
    },
    columnFiltersOnly() {
      const baseKeys = { somente_ativas: true };
      const out = {};
      Object.keys(this.searchFilters || {}).forEach((k) => {
        if (!baseKeys[k]) out[k] = this.searchFilters[k];
      });
      return out;
    },
    serverTableBaseFilters() {
      const base = {};
      if (!this.mostrarInativos) base.somente_ativas = '1';
      return base;
    },
    /** Reaponta a sele├º├úo para os objetos da p├ígina sem perder marcados em outras p├íginas. */
    resyncAposReload() {
      this.selecionadas = mergeSelectionWithPage(this.selecionadas, this.linhas, "id_linha");
    },
    /**
     * Mant├®m o checkbox da tabela coerente quando a sele├º├úo vem de fora
     * (deep link, linha rec├®m-criada, publica├º├úo de roteiriza├º├úo).
     */
    sincronizarCheckboxLinha(item) {
      if (!item || item.id_linha == null) {
        if (this.selecionadas.length) this.selecionadas = [];
        return;
      }
      const jaMarcada = this.selecionadas.some(
        (l) => Number(l.id_linha) === Number(item.id_linha)
      );
      if (jaMarcada) return;
      const row = this.linhas.find((l) => Number(l.id_linha) === Number(item.id_linha));
      this.selecionadas = [row || item];
    },
    /**
     * @param {object|null} item
     * @param {{ manterAba?: boolean }} [opcoes] manterAba: n├úo for├ºa a aba Mapa
     *        (pagina├º├úo em Par├ómetros), igualando Rotas/Cercas/Unidades.
     */
    selecionarLinha(item, opcoes = {}) {
      const wasCreating = this.creatingLinha;
      this.creatingLinha = false;
      if (wasCreating) this.clearCreateMapPreview();
      const manterAba = !!opcoes.manterAba;
      this.sincronizarCheckboxLinha(item);
      const split = this.$refs.detalheSplit;
      // Antes de trocar a prop: o watcher de `linha` no painel reseta a aba.
      if (manterAba && split && typeof split.preservarAbaNaProximaLinha === "function") {
        split.preservarAbaNaProximaLinha();
      }
      this.linhaSelecionada = item ? { ...item } : null;
      this.$nextTick(() => {
        const panel = this.$refs.detalheSplit;
        if (manterAba) {
          if (panel && typeof panel.focarMapaSemTrocarAba === "function") {
            panel.focarMapaSemTrocarAba();
          }
          return;
        }
        if (this.pendingFocusSecao === 'turnos') {
          setTimeout(() => this.focusSecaoTurnos(), 300);
          return;
        }
        if (this.initialDetailTabKey && panel && typeof panel.abrirAbaPorChave === "function") {
          panel.abrirAbaPorChave(this.initialDetailTabKey);
          this.initialDetailTabKey = null;
          return;
        }
        if (panel && typeof panel.mostrarLinhaNoMapa === "function") {
          panel.mostrarLinhaNoMapa();
          return;
        }
        if (panel && typeof panel.centralizarMapaNaLinha === "function") {
          panel.centralizarMapaNaLinha();
        }
      });
    },
    /**
     * Procura a linha na página carregada; se não estiver nela (paginação server-side),
     * busca pontualmente no servidor pelo id.
     */
    async encontraLinhaPorId(id) {
      if (id == null) return null;
      const local = (this.linhas || []).find((l) => Number(l.id_linha) === Number(id));
      if (local) return local;
      // Monta a query fora da chamada: um literal aqui viraria allowlist em apiEndpoints
      // (generate:api-endpoints) e descartaria sortBy/filter_* das demais chamadas.
      const consulta = Object.assign(
        { page: 1, rowsPerPage: 1, total: 'true' },
        { filter_id_linha: String(id) }
      );
      try {
        const response = await apiController.request(apiController.endpoints.getallLinhas, {
          data: consulta,
          silent: true,
        });
        const items = response && response.data && Array.isArray(response.data.items)
          ? response.data.items
          : [];
        return items.length ? this.decorateLinesWithRecency(items)[0] : null;
      } catch (e) {
        return null;
      }
    },
    async openPendingEditLinha() {
      if (this.pendingEditIdLinha == null) return;
      const id = this.pendingEditIdLinha;
      this.pendingEditIdLinha = null;
      const line = await this.encontraLinhaPorId(id);
      if (!line) return;
      if (this.pendingFocusSecao === 'turnos') {
        this.selecionarLinha(line);
        this.$nextTick(() => {
          setTimeout(() => this.focusSecaoTurnos(), 300);
        });
        return;
      }
      this.$nextTick(() => this.editItem(line));
    },
    clearHighlightUnidades() {
      this.highlightUnidadesField = false;
      if (this.highlightUnidadesTimer) {
        clearTimeout(this.highlightUnidadesTimer);
        this.highlightUnidadesTimer = null;
      }
    },
    clearLinhasHighlightSession() {
      try {
        sessionStorage.removeItem('linhasHighlightSecao');
        sessionStorage.removeItem('linhasHighlightId');
      } catch (e) { /* ignore */ }
    },
    /** Destaca visualmente o campo Unidades no formul├írio de edi├º├úo. */
    highlightSecaoUnidades(attempt = 0) {
      if (this.editedIndex < 0 && !this.linhaSelecionada) {
        if (attempt < 30) {
          setTimeout(() => this.highlightSecaoUnidades(attempt + 1), 100);
        }
        return;
      }

      const split = this.$refs.detalheSplit;
      if (split && typeof split.abrirAbaParametros === "function") {
        split.abrirAbaParametros();
      }
      this.highlightUnidadesField = true;
      this.pendingFocusSecao = null;
      this.clearLinhasHighlightSession();

      this.$nextTick(() => {
        const field = this.$refs.unidadesField;
        const el = field && field.$el;
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      if (this.highlightUnidadesTimer) {
        clearTimeout(this.highlightUnidadesTimer);
      }
      this.highlightUnidadesTimer = setTimeout(() => {
        this.highlightUnidadesField = false;
        this.highlightUnidadesTimer = null;
      }, 10000);
    },
    /** Abre a aba Turnos no painel de detalhes da linha selecionada. */
    focusSecaoTurnos(attempt = 0) {
      const line = this.linhaSelecionada;
      if (!line || line.id_linha == null) {
        if (attempt < 30) {
          setTimeout(() => this.focusSecaoTurnos(attempt + 1), 100);
        }
        return;
      }

      this.pendingFocusSecao = null;
      this.clearLinhasHighlightSession();
      this.$nextTick(() => {
        const panel = this.$refs.detalheSplit;
        if (panel && typeof panel.abrirAbaTurnos === "function") {
          panel.abrirAbaTurnos();
        }
      });
    },
    onDetalheChanged() {
      if (this.linhaSelecionada && this.linhaSelecionada.id_linha != null) {
        this.markLineAsRecentlyChanged(this.linhaSelecionada.id_linha);
      }
    },
    onRotasDetalheChanged() {
      this.onDetalheChanged();
      this.sincronizarDistanciasLinhaSelecionada();
    },
    markLineAsRecentlyChanged(idLinha) {
      const id = Number(idLinha);
      if (!Number.isFinite(id)) return;
      const value = Date.now();
      this.$set(this.lineRecencyById, String(id), value);
      const row = this.linhas.find((line) => Number(line.id_linha) === id);
      if (row) this.$set(row, '_recencySort', value);
    },
    decorateLinesWithRecency(lines) {
      return (lines || []).map((line) => {
        const id = Number(line && line.id_linha);
        const recent = this.lineRecencyById[String(id)];
        return {
          ...line,
          _recencySort: recent != null ? recent : (Number.isFinite(id) ? id : 0),
        };
      });
    },
    initialize() {
      if (!this.token) {
        this.token = sessionStorage.getItem('api');
      }
      if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
        const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
        this.serverSortBy = serverSortBy;
        this.serverSortDesc = serverSortDesc;
      }
      this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
      this.populaRecursos();
      this.populaEmpresas();
      this.populaClientes();
      this.populaTiposCerca();
      this.populaTiposRota();
      this.populaSentidos();
      this.populaTiposAberturasViagens();
      this.populaUnidades();
    },
    populaLinhas() {
      this.serverTableLoad();
    },
    serverTableLoad(options) {
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalLinhas,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      apiController.request(apiController.endpoints.getallLinhas, {
        data: params,
        onSuccess: (response) => {
          const data = response.data;
          const totalNum = data && data.total != null && data.total !== '' ? Number(data.total) : NaN;
          let linhasData = [];
          if (data && !Number.isNaN(totalNum) && Array.isArray(data.items)) {
            linhasData = data.items;
            const updates = computePageState(
              { items: data.items, total: totalNum },
              { page, rowsPerPage, sortByArr, sortDescArr },
              state,
              this.itemsPerPageLastOption
            );
            this.totalLinhas = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            linhasData = Array.isArray(data) ? data : [];
            this.totalLinhas = linhasData.length;
          }
          if (this.pendingPublishedLineIds.length) {
            const now = Date.now();
            this.pendingPublishedLineIds.forEach((id, index) => {
              this.$set(this.lineRecencyById, String(id), now - index);
            });
          }
          this.linhas = this.decorateLinesWithRecency(linhasData);
          if (this.pendingPublishedLineIds.length) {
            const order = new Map(this.pendingPublishedLineIds.map((id, index) => [Number(id), index]));
            this.linhas = this.linhas.slice().sort((a, b) => {
              const aOrder = order.has(Number(a.id_linha)) ? order.get(Number(a.id_linha)) : Number.MAX_SAFE_INTEGER;
              const bOrder = order.has(Number(b.id_linha)) ? order.get(Number(b.id_linha)) : Number.MAX_SAFE_INTEGER;
              return aOrder - bOrder;
            });
            const firstPublished = this.linhas.find((l) => order.has(Number(l.id_linha)));
            this.pendingPublishedLineIds = [];
            if (firstPublished) this.selecionarLinha(firstPublished);
          }
          this.loadingtable = false;
          this.resyncAposReload();
          this.openPendingEditLinha();
          if (this.pendingSelectIdLinha != null) {
            const created = this.linhas.find(
              (l) => Number(l.id_linha) === Number(this.pendingSelectIdLinha)
            );
            this.pendingSelectIdLinha = null;
            if (created) {
              if (created.cod_linha) {
                this.search = String(created.cod_linha);
              }
              this.selecionarLinha(created);
              return;
            }
          }
          if (this.linhaSelecionada && this.linhaSelecionada.id_linha != null) {
            const updated = this.linhas.find(
              (l) => Number(l.id_linha) === Number(this.linhaSelecionada.id_linha)
            );
            this.linhaSelecionada = updated ? { ...updated } : this.linhaSelecionada;
          }
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    async loadItemsForExport(onProgress) {
      const selected = this.selecionadas;
      if (selected && selected.length > 0) {
        if (typeof onProgress === "function") onProgress(100);
        return selected.slice();
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallLinhas,
            { data: params, silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalLinhas,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        mapItems: (items) => this.decorateLinesWithRecency(items),
        onProgress,
      });
    },
    populaTiposAberturasViagens() {
      apiController.request(apiController.endpoints.getallTiposaberturasviagens, {
        onSuccess: (response) => {
          this.tiposAberturasViagens = response.data;
        },
      });
    },
    populaEmpresasPermitidas() {
      // Ensure recursos is an array before filtering
      const recursosData = Array.isArray(this.recursos) ? this.recursos : [];
      this.empresasPermitidas = recursosData.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = Array.isArray(response.data) ? response.data : [];
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.populaEmpresasPermitidas();
            this.populaLinhas();
          },
          onError: () => {
            this.recursos = [];
            this.empresasPermitidas = [];
            this.linhas = [];
            this.loadingtable = false;
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = Array.isArray(response.data) ? response.data : [];
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatelinha");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertlinha");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletelinha");
            this.populaEmpresasPermitidas();
            this.populaLinhas();
          },
          onError: () => {
            this.recursos = [];
            this.empresasPermitidas = [];
            this.linhas = [];
            this.loadingtable = false;
          },
        });
      }
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          this.clientes = [];
        },
      });
    },
    clientesPorEmpresa(idEmpresa) {
      if (idEmpresa == null || idEmpresa === "") {
        return [];
      }
      const id = Number(idEmpresa);
      return this.clientes.filter((c) => Number(c.id_empresa) === id);
    },
    populaSentidos() {
      apiController.request(apiController.endpoints.getallSentidos, {
        onSuccess: (response) => {
          this.sentidos = response.data.map((sentido) => {
            const translated = translateDbField(
              sentido.translation_key,
              sentido.descricao_sentido
            );
            return {
                ...sentido,
                descricao_sentido: translated
              };
            });
        },
      });
    },
    populaUnidades() {
      this.loadingUnidades = true;
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = Array.isArray(response.data) ? response.data : [];
          this.loadingUnidades = false;
        },
        onError: () => {
          this.unidades = [];
          this.loadingUnidades = false;
        },
      });
    },
    populaUnidadesLinha(idLinha, unidadesFromItem) {
      if (!idLinha) {
        this.unidadesLinhaIds = [];
        return;
      }
      // Prefer├¬ncia: ids j├í agregados em getallLinhas (item.unidades).
      if (Array.isArray(unidadesFromItem) && unidadesFromItem.length) {
        this.unidadesLinhaIds = unidadesFromItem
          .map((id) => Number(id))
          .filter((n) => Number.isFinite(n) && n > 0);
        return;
      }
      if (Array.isArray(unidadesFromItem) && unidadesFromItem.length === 0) {
        this.unidadesLinhaIds = [];
        return;
      }

      const resolveLinked = (unidades) => {
        if (!unidades.length) {
          this.unidadesLinhaIds = [];
          return;
        }
        const requests = unidades.map((u) =>
          apiController
            .request(apiController.endpoints.getLinhasassociadas, {
              data: [u.id_unidade],
              silent: true,
            })
            .then((r) => ({ id_unidade: u.id_unidade, linhas: Array.isArray(r.data) ? r.data : [] }))
            .catch(() => ({ id_unidade: u.id_unidade, linhas: [] }))
        );
        Promise.all(requests).then((results) => {
          this.unidadesLinhaIds = results
            .filter((r) =>
              r.linhas.some((l) => Number(l.id_linha) === Number(idLinha))
            )
            .map((r) => Number(r.id_unidade));
        });
      };

      if (this.unidades && this.unidades.length) {
        resolveLinked(this.unidades);
        return;
      }

      this.loadingUnidades = true;
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = Array.isArray(response.data) ? response.data : [];
          this.loadingUnidades = false;
          resolveLinked(this.unidades);
        },
        onError: () => {
          this.unidades = [];
          this.unidadesLinhaIds = [];
          this.loadingUnidades = false;
        },
      });
    },
    /**
     * Substitui v├¡nculos linhaÔåöunidade: remove todos e reinsere os selecionados.
     */
    syncUnidadesLinha(idLinha) {
      if (idLinha == null) return Promise.resolve();
      const idLinhaNum = Number(idLinha);
      const ids = [...new Set(
        (this.unidadesLinhaIds || [])
          .map((id) => Number(id))
          .filter((n) => Number.isFinite(n) && n > 0)
      )];

      return apiController
        .request(apiController.endpoints.desassociaLinhasbulk, {
          data: [idLinhaNum],
          silent: true,
        })
        .then((res) => {
          if (res && res.data && res.data.erro) {
            throw new Error(res.data.mensagem || "desassociaLinhasbulk");
          }
          if (!ids.length) return null;
          const rows = ids.map((idUnidade) => [idUnidade, idLinhaNum]);
          return apiController.request(apiController.endpoints.associaLinhasbulk, {
            data: rows,
            silent: true,
          });
        })
        .then((res) => {
          if (res && res.data && res.data.erro) {
            throw new Error(res.data.mensagem || "associaLinhasbulk");
          }
          return res;
        })
        .catch((e) => {
          EventBus.$emit("show-error", { error: e });
          throw e;
        });
    },
    populaCercasPorLinha(id) {
      this.loadingcercas = true;
      
      // Fetch both regular cercas and padrao cercas
      Promise.all([
        apiController.request(apiController.endpoints.getCercasporlinha, {
          data: [id],
          silent: true,
        }),
        apiController.request(apiController.endpoints.getCercaspadraoporlinha, {
          data: [id],
          silent: true,
        }),
      ])
        .then((responses) => {
          const regularCercas = responses[0].data || [];
          const padraoCercas = responses[1].data || [];
          
          // Create a map of padrao cercas by id_cerca + id_sentido + id_tipo_cerca to avoid duplicates
          const padraoMap = new Map();
          padraoCercas.forEach(cerca => {
            const key = `${cerca.id_cerca}_${cerca.id_sentido}_${cerca.id_tipo_cerca}`;
            padraoMap.set(key, cerca);
          });
          
          // Create a map of regular cercas by the same key
          const regularMap = new Map();
          regularCercas.forEach(cerca => {
            const key = `${cerca.id_cerca}_${cerca.id_sentido}_${cerca.id_tipo_cerca}`;
            regularMap.set(key, cerca);
          });
          
          // Start with padrao cercas (they always should be shown)
          const mergedCercas = [];
          padraoMap.forEach((cerca, key) => {
            // Use padrao cerca data, but if there's a regular cerca, prefer its show_sinotico and other linhas_cercas fields
            const regularCerca = regularMap.get(key);
            
            // Determine show_sinotico: prefer regular cerca if exists, otherwise default based on tipo_cerca
            let showSinotico = null;
            if (regularCerca && regularCerca.show_sinotico !== undefined && regularCerca.show_sinotico !== null) {
              showSinotico = regularCerca.show_sinotico;
            } else if (cerca.id_tipo_cerca === 2 || cerca.id_tipo_cerca === 3) {
              // Default to true for tipo_cerca 2 (ponto inicial) or 3 (ponto final)
              showSinotico = 1;
            } else {
              showSinotico = cerca.show_sinotico || null;
            }
            
            const finalCerca = {
              ...cerca,
              // Prefer show_sinotico from regular cerca if it exists, otherwise default based on tipo_cerca
              show_sinotico: showSinotico,
              show_sinotico_extenso: showSinotico === 1 ? 'Sim' : 'N├úo',
              // Use ordem_parada from padrao cerca (from cercas_ordem)
              ordem_parada: cerca.ordem_parada || null,
              // Prefer tempo_chegada_minutos from regular cerca, otherwise null
              tempo_chegada_minutos: regularCerca ? regularCerca.tempo_chegada_minutos : (cerca.tempo_chegada_minutos || null),
            };
            mergedCercas.push(finalCerca);
          });
          
          // Add regular cercas that are not padrao
          regularMap.forEach((cerca, key) => {
            if (!padraoMap.has(key)) {
              mergedCercas.push(cerca);
            }
          });
          
          // Auto-assign ordem_parada if it's null or 0 (for old data)
          let hasAutoAssigned = false;
          this.cercasLinha = mergedCercas.map((cerca, index) => {
            if (!cerca.ordem_parada || cerca.ordem_parada === 0) {
              cerca.ordem_parada = index + 1;
              hasAutoAssigned = true;
            }
            return cerca;
          });
          
          // Sort by ordem_parada to maintain order
          this.cercasLinha.sort((a, b) => {
            return (a.ordem_parada || 0) - (b.ordem_parada || 0);
          });
          
          // Mark cercas as edited so they get saved with the new ordem values
          if (hasAutoAssigned) {
            this.editedCercas = true;
          }
          
          this.loadingcercas = false;
          console.log(this.cercasLinha);
        })
        .catch((e) => {
          this.loadingcercas = false;
          EventBus.$emit('show-error', { error: e });
        });
    },
    populaRotasPorLinha(id) {
      this.loadingrotas = true;
      apiController.request(apiController.endpoints.getRotaspadraoporlinha, {
        data: [id],
        onSuccess: (response) => {
          this.rotasLinha = Array.isArray(response.data) ? response.data : [];
          this.calculaDistanciasLinha();
          this.loadingrotas = false;
        },
        onError: () => {
          this.loadingrotas = false;
        },
      });
    },
    populaSublinhas() {
      this.loadingsublinhas = true;
      this.sublinhas = this.editedItem.sublinhas;
      this.loadingsublinhas = false;
    },
    populaTiposCerca() {
      apiController.request(apiController.endpoints.getTiposcerca, {
        onSuccess: (response) => {
          this.tiposCerca = response.data.map(tipoCerca => {
            const translated = translateDbField(
              tipoCerca.translation_key,
              tipoCerca.descricao_tipo_cerca
            );
            return {
              ...tipoCerca,
              descricao_tipo_cerca: translated
            };
          });
        },
      });
    },
    populaTiposRota() {
      apiController.request(apiController.endpoints.getTiposrota, {
        onSuccess: (response) => {
          this.tiposRota = response.data.map(tipoRota => {
            const translated = translateDbField(
              tipoRota.translation_key,
              tipoRota.descricao_tipo_rota
            );
            return {
              ...tipoRota,
              descricao_tipo_rota: translated
            };
          });
        },
      });
    },
    velocidadeMaximaChanged() {
      if (this.alarmeVelocidadeMaxima == false) {
        this.velocidadeMaxima = 0;
      }
    },
    filtroEmpresaChanged() {
      this.filteredRotas = this.rotas.filter((element) => {
        return element.id_empresa == this.editedItem.id_empresa;
      });
      if (this.editedItem.id_cliente != null) {
        const stillValid = this.clientes.some(
          (c) => c.id_cliente === this.editedItem.id_cliente && c.id_empresa === this.editedItem.id_empresa
        );
        if (!stillValid) {
          this.suppressClienteConfirmChange = true;
          this.editedItem.id_cliente = null;
          this.$nextTick(() => {
            this.suppressClienteConfirmChange = false;
          });
        }
      }
    },
    applyScopedClienteEmpresaOnCreate() {
      this.scopedClienteCreateLocked = false;
      if (this.editedIndex !== -1 || !shouldLockClienteOnCreate()) {
        return;
      }
      const id = getScopedClienteIdForCreate();
      if (id == null) {
        return;
      }
      const c = this.clientes.find((x) => Number(x.id_cliente) === Number(id));
      if (!c || c.id_empresa == null) {
        return;
      }
      this.editedItem.id_cliente = id;
      this.editedItem.id_empresa = c.id_empresa;
      this.scopedClienteCreateLocked = true;
      this.filtroEmpresaChanged();
    },
    applySingleEmpresaIfOnlyOption() {
      if (this.editedIndex !== -1) {
        return;
      }
      if (this.scopedClienteCreateLocked) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
      this.filtroEmpresaChanged();
    },
    nomeClienteById(id) {
      if (id == null || id === '') return 'ÔÇö';
      const c = (this.clientes || []).find((x) => Number(x.id_cliente) === Number(id));
      return c && c.nome_cliente ? c.nome_cliente : String(id);
    },
    sameClienteId(a, b) {
      if (a == null || a === '') return b == null || b === '';
      if (b == null || b === '') return false;
      return Number(a) === Number(b);
    },
    onClienteChange(newVal) {
      if (this.suppressClienteConfirmChange) return;
      // Inclus├úo: n├úo exige confirma├º├úo
      if (this.editedIndex === -1) {
        this.lastConfirmedIdCliente = newVal != null && newVal !== '' ? newVal : null;
        return;
      }
      if (this.sameClienteId(newVal, this.lastConfirmedIdCliente)) return;

      this.pendingIdCliente = newVal != null && newVal !== '' ? newVal : null;
      this.confirmDialogType = 'cliente';
      this.mensagemdialog = this.$t('crudLinhas.messages.confirmClientChange', {
        code: this.editedItem.cod_linha || this.editedItem.nome_linha || '',
        from: this.nomeClienteById(this.lastConfirmedIdCliente),
        to: this.nomeClienteById(this.pendingIdCliente),
      });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    confirmClienteChange() {
      this.lastConfirmedIdCliente =
        this.pendingIdCliente != null && this.pendingIdCliente !== ''
          ? this.pendingIdCliente
          : null;
      this.pendingIdCliente = null;
      this.confirmDialog = false;
      this.confirmDialogType = 'delete';
    },
    dismissClienteChange() {
      this.suppressClienteConfirmChange = true;
      this.editedItem.id_cliente = this.lastConfirmedIdCliente;
      this.pendingIdCliente = null;
      this.confirmDialog = false;
      this.confirmDialogType = 'delete';
      this.$nextTick(() => {
        this.suppressClienteConfirmChange = false;
      });
    },
    dismissConfirmDialog() {
      if (this.confirmDialogType === 'cliente') {
        this.dismissClienteChange();
        return;
      }
      this.confirmDialog = false;
      this.confirmDialogType = 'delete';
    },

    async resolveHistoricoSessaoCrud() {
      if (!this.historicoSessaoOrigemId) return;
      try {
        const relation = await resolveHistoricoRoteirizacaoCrudSession(this.historicoSessaoOrigemId);
        if (relation && relation.id_sessao_crud) {
          this.historicoSessaoId = relation.id_sessao_crud;
        }
      } catch (e) {
        this.historicoSessaoId = null;
      }
    },
    preencheLinha(item) {
      this.editedItem = Object.assign({}, item);
      this.lastConfirmedIdCliente = item && item.id_cliente != null ? item.id_cliente : null;
      this.pendingIdCliente = null;

      this.filtroEmpresaChanged();
      this.populaCercasPorLinha(this.editedItem.id_linha);
      this.populaRotasPorLinha(this.editedItem.id_linha);
      this.populaUnidadesLinha(this.editedItem.id_linha, item && item.unidades);
      this.populaSublinhas();

      this.isAtiva = this.editedItem.ativa == 1 ? 1 : 0;
      this.isCircular = this.editedItem.circular == 1 ? 1 : 0;
      this.isSublinha = this.editedItem.id_linha_principal ? 1 : 0;
      this.alarmeForaRota = this.editedItem.alarme_fora_rota == 1 ? 1 : 0;
      this.alarmeVelocidadeMaxima = this.editedItem.alarme_velocidade_maxima == 1 ? 1 : 0;
      this.alarmeTempoParado = this.editedItem.alarme_tempo_parado == 1 ? 1 : 0;
      this.atualizaInicioViagem = this.editedItem.atualiza_inicio_viagem == 1 ? 1 : 0;
      this.toleranciaForaRota = this.editedItem.tolerancia_fora_rota;
      this.velocidadeMaxima = this.editedItem.velocidade_maxima;
      this.limiteTempoParado = this.editedItem.limite_tempo_parado;
      this.limiteTempoLargada = this.editedItem.tempo_maximo_largada;
      const idPrincipal = this.editedItem.id_linha_principal;
      this.linhaPrincipal =
        this.linhas.find((l) => Number(l.id_linha) === Number(idPrincipal)) ||
        (idPrincipal != null ? { id_linha: idPrincipal } : null);
    },
    onMapAction({ action, item, lat, lng, active, geometry, idRota } = {}) {
      if (action === "create-linha") {
        this.startCreateLinha();
        return;
      }
      if (action === "close-create") {
        this.close({ fromMap: true });
        return;
      }
      if (action === "select-linha-map") {
        if (item && item.id_linha != null) {
          this.selecionarLinha(item, { manterAba: true });
        }
        return;
      }
      if (action === "create-fence-on-line") {
        this.startCreateCercaNaLinha(idRota);
        return;
      }
      if (action === "route-selected-for-fence-create") {
        if (!this.creatingCercaNaLinha || !item || item.id_rota == null) return;
        this.cercaNaLinhaRotaId = Number(item.id_rota);
        return;
      }
      if (!this.creatingCercaNaLinha) return;
      if (action === "pick-location-mode") {
        this.pickLocationAtivoCerca = !!active;
        return;
      }
      if (action === "pick-location") {
        this.aplicarLocalizacaoNovaCerca(lat, lng);
        return;
      }
      if (action === "draw-polygon-mode") {
        this.desenhoPoligonoAtivoCerca = !!active;
        return;
      }
      if (action === "fence-polygon-draft") {
        this.aplicarGeometriaNovaCerca(geometry, { preview: false });
        return;
      }
      if (action === "fence-polygon-drawn" || action === "fence-geometry-changed") {
        this.aplicarGeometriaNovaCerca(geometry);
      }
    },
    createRotaSelectText(item) {
      if (!item) return "";
      const cod = item.cod_rota != null ? String(item.cod_rota).trim() : "";
      const nome = item.nome_rota != null ? String(item.nome_rota).trim() : "";
      if (cod && nome) return `${cod} ÔÇö ${nome}`;
      return cod || nome || "";
    },
    async resolveCreatePreviewRotaDetail(itemOrId) {
      if (itemOrId == null || itemOrId === "") return null;
      const base = typeof itemOrId === "object" ? itemOrId : { id_rota: itemOrId };
      if (base.geojson || base.shape) return base;
      const id = Number(base.id_rota);
      if (!Number.isFinite(id)) return null;
      try {
        const res = await apiController.request(apiController.endpoints.getRotaporid, {
          params: { id },
          silent: true,
        });
        const rows = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
        return rows[0] || base;
      } catch (e) {
        return base.id_rota != null ? base : null;
      }
    },
    createRotaKey(rota) {
      if (!rota || rota.id_rota == null) return null;
      return String(rota.id_rota) + "|" + String(rota.id_sentido);
    },
    async onCreateRotaSelected(item) {
      if (!this.creatingLinha || !item || item.id_rota == null) {
        this.createItemRota.id_rota = null;
        this.createRotaSelectedDetail = null;
        return;
      }
      this.createItemRota.id_rota = Number(item.id_rota);
      this.createRotaSelectedDetail = await this.resolveCreatePreviewRotaDetail(item);
    },
    /**
     * Associa a rota ao preview da linha. Espelha addRotaAssociacao do editor de mapa:
     * rota, tipo e sentido são obrigatórios porque rotas_linhas grava os três.
     */
    addCreatePreviewRota() {
      if (this.createItemRota.id_rota == null) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.validation.routeRequired"),
          tipo: "warning",
        });
        return;
      }
      if (this.createItemRota.id_tipo_rota == null) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.validation.routeTypeRequired"),
          tipo: "warning",
        });
        return;
      }
      if (this.createItemRota.id_sentido == null || this.createItemRota.id_sentido === "") {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.map.selectDirectionFirst"),
          tipo: "warning",
        });
        return;
      }
      const duplicada = this.createPreviewRotas.some(
        (r) =>
          Number(r.id_rota) === Number(this.createItemRota.id_rota) &&
          Number(r.id_sentido) === Number(this.createItemRota.id_sentido)
      );
      if (duplicada) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.map.routeAlreadyAssociated"),
          tipo: "error",
        });
        return;
      }
      const detail = this.createRotaSelectedDetail || { id_rota: this.createItemRota.id_rota };
      const tipo = (this.tiposRota || []).find(
        (t) => Number(t.id_tipo_rota) === Number(this.createItemRota.id_tipo_rota)
      );
      const sentido = (this.sentidos || []).find(
        (s) => Number(s.id_sentido) === Number(this.createItemRota.id_sentido)
      );
      this.createPreviewPreferUnidade = false;
      this.createPreviewRotas = [
        ...this.createPreviewRotas,
        {
          ...detail,
          id_rota: Number(this.createItemRota.id_rota),
          id_tipo_rota: this.createItemRota.id_tipo_rota,
          descricao_tipo_rota: tipo ? tipo.descricao_tipo_rota : null,
          cod_tipo_rota: tipo ? tipo.cod_tipo_rota : null,
          id_sentido: this.createItemRota.id_sentido,
          descricao_sentido: sentido ? sentido.descricao_sentido : null,
          ativa: 1,
        },
      ];
      this.resetCreateItemRota();
    },
    resetCreateItemRota() {
      this.createItemRota = {
        id_rota: null,
        id_tipo_rota: null,
        id_sentido: null,
      };
      this.createRotaSelectedDetail = null;
      this.resetCreateRotaSelect();
    },
    resetCreateRotaSelect() {
      this.$nextTick(() => {
        const sel = this.$refs.createRotaSelect;
        if (sel && typeof sel.resetData === "function") sel.resetData();
      });
    },
    removeCreatePreviewRota(rota) {
      const key = this.createRotaKey(rota);
      if (key == null) return;
      this.createPreviewRotas = this.createPreviewRotas.filter(
        (r) => this.createRotaKey(r) !== key
      );
      // Sem a rota, a cerca ficaria órfã num sentido sem traçado: sai junto.
      this.createPreviewCercasLinha = this.createPreviewCercasLinha.filter(
        (c) => c._rotaKey !== key
      );
      if (this.createItemCerca._rotaKey === key) {
        this.createItemCerca._rotaKey = null;
      }
      // Sem rota o bloco de cercas fica desabilitado: a cerca em selecao nao pode
      // ficar pendurada no mapa.
      if (!this.createPreviewRotas.length) {
        this.resetCreateItemCerca({ keepRota: false });
      }
      this.createPreviewPreferUnidade = false;
    },
    async onCreateUnidadesChange(ids) {
      if (!this.creatingLinha) return;
      const next = Array.isArray(ids) ? ids.map(Number).filter((n) => Number.isFinite(n)) : [];
      const prev = this.createUnidadesIdsPrev || [];
      const added = next.filter((id) => !prev.includes(id));
      this.createUnidadesIdsPrev = next.slice();
      const focusId = added.length ? added[added.length - 1] : next.length ? next[next.length - 1] : null;
      if (focusId == null) {
        this.createPreviewCerca = null;
        this.createPreviewPreferUnidade = false;
        return;
      }
      const unit = (this.unidades || []).find((u) => Number(u.id_unidade) === Number(focusId));
      if (!unit || unit.id_cerca_centro == null || unit.id_cerca_centro === "") {
        this.createPreviewCerca = null;
        this.createPreviewPreferUnidade = false;
        return;
      }
      try {
        const res = await apiController.request(apiController.endpoints.getCercaporid, {
          params: { id: Number(unit.id_cerca_centro) },
          silent: true,
        });
        const rows = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
        this.createPreviewCerca = rows[0] || null;
        this.createPreviewPreferUnidade = !!this.createPreviewCerca;
      } catch (e) {
        this.createPreviewCerca = null;
        this.createPreviewPreferUnidade = false;
      }
    },
    clearCreateMapPreview() {
      this.createPreviewRotas = [];
      this.createPreviewCerca = null;
      this.createPreviewCercasLinha = [];
      this.createPreviewPreferUnidade = false;
      this.createUnidadesIdsPrev = [];
      this.resetCreateItemCerca({ keepRota: false });
      this.resetCreateItemRota();
    },
    resetCreateItemCerca({ keepRota = true } = {}) {
      // Mantém a rota escolhida entre adições: o caso comum é cadastrar várias
      // cercas seguidas para a mesma rota.
      const rotaKeyAtual = keepRota && this.createItemCerca ? this.createItemCerca._rotaKey : null;
      this.createItemCerca = {
        id_cerca: null,
        nome_cerca: null,
        id_tipo_cerca: null,
        show_sinotico: 1,
        tempo_chegada_minutos: 0,
        id_rota: null,
        _rotaKey: rotaKeyAtual,
        id_sentido: null,
        ordem_parada: 1,
      };
      this.createShowSinotico = true;
      this.createCercaSelectedDetail = null;
      this.$nextTick(() => {
        const sel = this.$refs.createCercaSelect;
        if (sel && typeof sel.resetData === "function") sel.resetData();
      });
    },
    createCercaSelectText(item) {
      if (!item) return "";
      const cod = item.cod_cerca != null ? String(item.cod_cerca).trim() : "";
      const nome = item.nome_cerca != null ? String(item.nome_cerca).trim() : "";
      if (cod && nome) return `${cod} - ${nome}`;
      return cod || nome || "";
    },
    onCreateCercaSelected(item) {
      if (!item || item.id_cerca == null) {
        this.createItemCerca.id_cerca = null;
        this.createCercaSelectedDetail = null;
        return;
      }
      this.createItemCerca.id_cerca = item.id_cerca;
      this.createCercaSelectedDetail = item;
    },
    createTipoCercaChanged() {
      if (this.createItemCerca.id_tipo_cerca == 2 || this.createItemCerca.id_tipo_cerca == 3) {
        this.createShowSinotico = true;
      }
    },
    addCreatePreviewCerca() {
      if (!this.createItemCerca.id_cerca) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.messages.fenceRequired"),
          tipo: "warning",
        });
        return;
      }
      if (!this.createItemCerca.id_tipo_cerca) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.validation.fenceTypeRequired"),
          tipo: "warning",
        });
        return;
      }
      // A cerca herda o sentido da rota escolhida: cercas_linhas não tem id_rota,
      // o vínculo cerca-rota é exatamente o id_sentido.
      const rotaSelecionada = this.createRotasParaCercaOptions.find(
        (r) => r._rotaKey === this.createItemCerca._rotaKey
      );
      if (!rotaSelecionada) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.map.routeByFencesNoRoute"),
          tipo: "warning",
        });
        return;
      }
      this.createItemCerca.id_rota = rotaSelecionada.id_rota;
      this.createItemCerca.id_sentido = rotaSelecionada.id_sentido;
      const ordem = Number(this.createItemCerca.ordem_parada);
      if (!Number.isFinite(ordem) || ordem <= 0) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.validation.required"),
          tipo: "warning",
        });
        return;
      }
      const duplicada = this.createPreviewCercasLinha.some(
        (c) =>
          Number(c.id_cerca) === Number(this.createItemCerca.id_cerca) &&
          this.cercaSentidosDuplicados(c.id_sentido, this.createItemCerca.id_sentido)
      );
      if (duplicada) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.messages.fenceAlreadyExists"),
          tipo: "error",
        });
        return;
      }
      const tipoCerca = this.tiposCerca.find(
        (t) => Number(t.id_tipo_cerca) === Number(this.createItemCerca.id_tipo_cerca)
      );
      const sentido = this.sentidos.find(
        (s) => Number(s.id_sentido) === Number(this.createItemCerca.id_sentido)
      );
      const detail = this.createCercaSelectedDetail || {};
      const payload = {
        ...this.createItemCerca,
        nome_cerca: detail.nome_cerca || this.createItemCerca.nome_cerca,
        cod_cerca: detail.cod_cerca,
        descricao_tipo_cerca: tipoCerca ? tipoCerca.descricao_tipo_cerca : null,
        cod_tipo_cerca: tipoCerca ? tipoCerca.codigo_cerca : null,
        descricao_sentido: sentido ? sentido.descricao_sentido : null,
        show_sinotico: this.createShowSinotico ? 1 : 0,
        tempo_chegada_minutos:
          this.createItemCerca.tempo_chegada_minutos != null
            ? Number(this.createItemCerca.tempo_chegada_minutos)
            : 0,
      };
      if (
        wouldBreakTerminusOrder(this.createPreviewCercasLinha, payload, null, {
          rotas: this.createPreviewRotas,
        })
      ) {
        this.dialogTerminusOrder = true;
        return;
      }
      this.createPreviewCercasLinha = [...this.createPreviewCercasLinha, payload];
      this.resetCreateItemCerca();
    },
    removeCreatePreviewCerca(cerca) {
      if (!cerca) return;
      this.createPreviewCercasLinha = this.createPreviewCercasLinha.filter(
        (c) =>
          !(
            Number(c.id_cerca) === Number(cerca.id_cerca) &&
            Number(c.id_sentido) === Number(cerca.id_sentido) &&
            c._rotaKey === cerca._rotaKey
          )
      );
    },
    /** Cercas do preview pertencentes a uma rota, na ordem de parada. */
    createCercasPorRota(rotaKey) {
      return (this.createPreviewCercasLinha || [])
        .filter((c) => c._rotaKey === rotaKey)
        .slice()
        .sort((a, b) => (Number(a.ordem_parada) || 0) - (Number(b.ordem_parada) || 0));
    },
    applyCreatePreviewToPersist() {
      if (this.createPreviewRotas.length) {
        this.rotasLinha = this.createPreviewRotas.map((r) => ({
          id_rota: r.id_rota,
          nome_rota: r.nome_rota,
          cod_rota: r.cod_rota,
          id_tipo_rota: r.id_tipo_rota != null ? r.id_tipo_rota : 1,
          id_sentido: r.id_sentido,
          descricao_sentido: r.descricao_sentido,
          descricao_tipo_rota: r.descricao_tipo_rota,
        }));
        this.editedRotas = true;
      }
      if (this.createPreviewCercasLinha.length) {
        this.cercasLinha = this.createPreviewCercasLinha.map((c) => ({ ...c }));
        this.editedCercas = true;
      }
    },
    startCreateLinha() {
      this.creatingLinha = true;
      this.createValidationAttempted = false;
      this.scopedClienteCreateLocked = false;
      this.linhaAntesDeCriar = this.linhaSelecionada;
      this.linhaSelecionada = null;
      this.editedIndex = -1;
      this.resetaLinha();
      this.clearHighlightUnidades();
      this.clearCreateMapPreview();
      this.$nextTick(() => {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
        this.$nextTick(() => {
          const form = this.$refs.formCreate;
          if (form && typeof form.resetValidation === "function") form.resetValidation();
          const split = this.$refs.detalheSplit;
          if (split && typeof split.openCreateDrawer === "function") {
            split.openCreateDrawer({ silent: true });
          }
        });
      });
    },
    saveParametros() {
      this.save();
    },
    defaultNovaCercaItem() {
      return {
        cod_cerca: null,
        nome_cerca: null,
        cod_integracao: null,
        shape: null,
        geojson: null,
        ativa: true,
        endereco: null,
        lat_centro: null,
        lng_centro: null,
        alarme_velocidade: null,
        velocidade_maxima: null,
        is_circular: null,
        raio_mts: null,
        id_empresa: null,
        id_cliente: null,
        observacoes: null,
      };
    },
    /** Abre o drawer de cria├º├úo de cerca a partir da FAB do mapa, associada ├á linha ativa. */
    startCreateCercaNaLinha(idRotaSelecionada) {
      if (!this.linhaSelecionada || this.linhaSelecionada.id_linha == null) return;
      const rotaId = idRotaSelecionada != null && idRotaSelecionada !== ""
        ? Number(idRotaSelecionada)
        : null;
      this.cercaNaLinhaRotaId = Number.isFinite(rotaId) ? rotaId : null;
      this.creatingCercaNaLinha = true;
      this.novaCercaItem = this.defaultNovaCercaItem();
      this.novaCercaItem.id_empresa = this.linhaSelecionada.id_empresa != null ? this.linhaSelecionada.id_empresa : null;
      this.novaCercaItem.id_cliente = this.linhaSelecionada.id_cliente != null ? this.linhaSelecionada.id_cliente : null;
      this.novaCercaAlarmeEntrada = false;
      this.novaCercaAlarmeSaida = false;
      this.novaCercaAlarmeVelocidade = false;
      this.$nextTick(() => {
        const form = this.$refs.formCreateCerca;
        if (form && typeof form.resetValidation === "function") form.resetValidation();
      });
    },
    onCercaNaLinhaRotaSelect(idRota) {
      const split = this.$refs.detalheSplit;
      if (idRota == null || idRota === "") {
        this.cercaNaLinhaRotaId = null;
        if (split && typeof split.setCercaCreateRouteId === "function") {
          split.setCercaCreateRouteId(null);
        }
        return;
      }
      this.cercaNaLinhaRotaId = Number(idRota);
      if (split && typeof split.setCercaCreateRouteId === "function") {
        split.setCercaCreateRouteId(this.cercaNaLinhaRotaId);
      }
    },
    resetNovaCercaForm() {
      this.novaCercaItem = this.defaultNovaCercaItem();
      this.novaCercaAlarmeEntrada = false;
      this.novaCercaAlarmeSaida = false;
      this.novaCercaAlarmeVelocidade = false;
      this.$nextTick(() => {
        const form = this.$refs.formCreateCerca;
        if (form && typeof form.resetValidation === "function") form.resetValidation();
      });
    },
    previewNovaCercaNoMapa(opts) {
      const split = this.$refs.detalheSplit;
      if (split && typeof split.previewAndFocusCerca === "function") {
        split.previewAndFocusCerca(this.novaCercaItem, opts);
      }
    },
    isLatitudeCerca(lat) {
      return lat != "" && isFinite(lat) && Math.abs(lat) <= 90;
    },
    isLongitudeCerca(lng) {
      return lng != "" && isFinite(lng) && Math.abs(lng) <= 180;
    },
    aplicarLocalizacaoNovaCerca(lat, lng) {
      if (!this.isLatitudeCerca(lat) || !this.isLongitudeCerca(lng)) return;
      this.novaCercaItem.lat_centro = Number(Number(lat).toFixed(6));
      this.novaCercaItem.lng_centro = Number(Number(lng).toFixed(6));
      this.previewNovaCercaNoMapa({ focus: false });
    },
    aplicarGeometriaNovaCerca(geometry, { preview = true } = {}) {
      if (!geometry || typeof geometry !== "object") return;
      const shape =
        geometry.shape == null
          ? null
          : typeof geometry.shape === "string"
            ? geometry.shape
            : JSON.stringify(geometry.shape);
      const geojson =
        geometry.geojson == null
          ? null
          : typeof geometry.geojson === "string"
            ? geometry.geojson
            : JSON.stringify(geometry.geojson);
      this.$set(this.novaCercaItem, "shape", shape);
      this.$set(this.novaCercaItem, "geojson", geojson);
      this.$set(
        this.novaCercaItem,
        "is_circular",
        geometry.is_circular != null ? Number(geometry.is_circular) : this.novaCercaItem.is_circular,
      );
      this.$set(
        this.novaCercaItem,
        "raio_mts",
        geometry.raio_mts != null ? geometry.raio_mts : this.novaCercaItem.raio_mts,
      );
      if (geometry.lat_centro != null) this.$set(this.novaCercaItem, "lat_centro", geometry.lat_centro);
      if (geometry.lng_centro != null) this.$set(this.novaCercaItem, "lng_centro", geometry.lng_centro);
      if (preview) this.previewNovaCercaNoMapa({ focus: false });
    },
    toggleNovaCercaPickLocation() {
      const split = this.$refs.detalheSplit;
      if (split && typeof split.setPickLocationMode === "function") {
        split.setPickLocationMode(!this.pickLocationAtivoCerca);
      }
    },
    toggleNovaCercaDesenhoPoligono() {
      const split = this.$refs.detalheSplit;
      if (split && typeof split.setDrawPolygonMode === "function") {
        split.setDrawPolygonMode(!this.desenhoPoligonoAtivoCerca);
      }
    },
    limparPoligonoNovaCerca() {
      this.$set(this.novaCercaItem, "shape", null);
      this.$set(this.novaCercaItem, "geojson", null);
      this.previewNovaCercaNoMapa({ focus: false });
    },
    novaCercaCircularChanged() {
      const circular = this.novaCercaItem.is_circular == 1 || this.novaCercaItem.is_circular === true;
      this.novaCercaItem.is_circular = circular ? 1 : 0;
      const split = this.$refs.detalheSplit;
      if (circular) {
        if (!this.novaCercaItem.raio_mts || Number(this.novaCercaItem.raio_mts) <= 0) {
          this.novaCercaItem.raio_mts = 50;
        }
        this.$set(this.novaCercaItem, "shape", null);
        this.$set(this.novaCercaItem, "geojson", null);
        if (split && typeof split.setDrawPolygonMode === "function") split.setDrawPolygonMode(false);
        this.desenhoPoligonoAtivoCerca = false;
      } else {
        this.novaCercaItem.raio_mts = 0;
        if (split && typeof split.setPickLocationMode === "function") split.setPickLocationMode(false);
        this.pickLocationAtivoCerca = false;
        const shape = this.novaCercaItem.shape;
        const empty =
          shape == null ||
          shape === "" ||
          (typeof shape === "string" && shape.trim() === "[]");
        if (empty && split && typeof split.setDrawPolygonMode === "function") {
          split.setDrawPolygonMode(true);
          this.desenhoPoligonoAtivoCerca = true;
        }
      }
      this.previewNovaCercaNoMapa({ focus: false });
    },
    novaCercaGetMarkerFromEndereco() {
      if (!this.novaCercaItem.endereco) return;
      this.loadingEnderecoCerca = true;
      axios
        .get(
          GeoCodeBaseUrl +
          encodeURIComponent(this.novaCercaItem.endereco) +
          "&limit=1&types=address" +
          "&access_token=" + GeoCodeApiKey
        )
        .then((response) => {
          this.novaCercaItem.lat_centro = response.data.features[0].properties.coordinates.latitude;
          this.novaCercaItem.lng_centro = response.data.features[0].properties.coordinates.longitude;
          this.novaCercaItem.shape = null;
          this.previewNovaCercaNoMapa();
          this.loadingEnderecoCerca = false;
        })
        .catch((e) => {
          this.loadingEnderecoCerca = false;
          EventBus.$emit('show-error', { error: e });
        });
    },
    novaCercaGetMarkerFromLatLong() {
      if (this.novaCercaItem.lat_centro && this.novaCercaItem.lng_centro) {
        this.previewNovaCercaNoMapa();
      }
    },
    /**
     * Cria a cerca nova e associa ├á linha ativa: insere via /insertcerca e recalcula o
     * tra├ºado pelo vroom (/solve define a ordem, com fallback para /plan).
     */
    async saveNovaCercaNaLinha() {
      const split = this.$refs.detalheSplit;
      if (split && typeof split.finalizeDrawFenceIfPending === "function") {
        split.finalizeDrawFenceIfPending();
      }
      await this.$nextTick();

      const form = this.$refs.formCreateCerca;
      const valid = form ? form.validate() : this.formValidadoCerca;
      if (!valid) return;
      if (this.cercaNaLinhaRotaId == null) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.map.createFenceSelectRouteHint"),
          tipo: "warning",
        });
        return;
      }

      const item = this.novaCercaItem;
      const circular = item.is_circular == 1 || item.is_circular === true;
      item.is_circular = circular ? 1 : 0;

      if (circular) {
        const raio = Number(item.raio_mts);
        if (
          !Number.isFinite(raio) ||
          raio <= 0 ||
          !this.isLatitudeCerca(item.lat_centro) ||
          !this.isLongitudeCerca(item.lng_centro)
        ) {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("geofence.circularGeometryRequired"),
            tipo: "error",
          });
          return;
        }
        item.shape = null;
        item.geojson = null;
      } else {
        const shape = item.shape;
        const empty =
          shape == null || shape === "" || (typeof shape === "string" && shape.trim() === "[]");
        if (empty) {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("geofence.shapeRequired"),
            tipo: "error",
          });
          return;
        }
      }

      const idCliente =
        item.id_cliente != null && item.id_cliente !== ""
          ? Number(item.id_cliente)
          : null;
      const idEmpresaRaw =
        item.id_empresa != null && item.id_empresa !== ""
          ? Number(item.id_empresa)
          : null;
      // Com cliente, omite empresa: o backend resolve e evita 400 por mismatch.
      const idEmpresa = Number.isFinite(idCliente)
        ? null
        : Number.isFinite(idEmpresaRaw)
          ? idEmpresaRaw
          : null;

      const payload = {
        cod_cerca: item.cod_cerca,
        nome_cerca: item.nome_cerca,
        cod_integracao:
          item.cod_integracao != null && String(item.cod_integracao).trim() !== ""
            ? String(item.cod_integracao).trim()
            : null,
        alarme_entrada: this.novaCercaAlarmeEntrada ? 1 : 0,
        alarme_saida: this.novaCercaAlarmeSaida ? 1 : 0,
        endereco: item.endereco || null,
        shape:
          item.shape != null && typeof item.shape !== "string"
            ? JSON.stringify(item.shape)
            : item.shape,
        lat_centro: item.lat_centro,
        lng_centro: item.lng_centro,
        alarme_velocidade: this.novaCercaAlarmeVelocidade ? 1 : 0,
        velocidade_maxima: item.velocidade_maxima || null,
        geojson:
          item.geojson != null && typeof item.geojson !== "string"
            ? JSON.stringify(item.geojson)
            : item.geojson,
        is_circular: circular ? 1 : 0,
        raio_mts: circular ? Number(item.raio_mts) : item.raio_mts != null ? Number(item.raio_mts) || 0 : null,
        observacoes: item.observacoes || null,
        id_empresa: idEmpresa,
        id_cliente: Number.isFinite(idCliente) ? idCliente : null,
      };

      this.savingNovaCerca = true;
      try {
        const result = split && typeof split.criarCercaEAssociarNaLinha === "function"
          ? await split.criarCercaEAssociarNaLinha(payload, { idRota: this.cercaNaLinhaRotaId })
          : { ok: false, message: null };
        if (!result || !result.ok) {
          EventBus.$emit("show-alert", {
            mensagem: (result && result.message) || this.$t("geofence.updateTable.error.insert"),
            tipo: "error",
          });
          return;
        }
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.map.fenceCreatedAndRouted"),
          tipo: "success",
        });
        this.close();
      } finally {
        this.savingNovaCerca = false;
      }
    },
    editItem(item) {
      this.scopedClienteCreateLocked = false;
      let focusSecao = this.pendingFocusSecao;
      if (!focusSecao) {
        try {
          const stored = sessionStorage.getItem('linhasHighlightSecao');
          if (stored === 'unidades' || stored === 'turnos') focusSecao = stored;
        } catch (e) { /* ignore */ }
      }
      if (focusSecao === 'turnos') {
        this.pendingFocusSecao = 'turnos';
        this.selecionarLinha(item);
        this.$nextTick(() => {
          setTimeout(() => this.focusSecaoTurnos(), 300);
        });
        return;
      }

      this.editedIndex = item && item.id_linha != null ? 0 : -1;
      this.preencheLinha(item);
      this.selecionarLinha(item);
      if (focusSecao === 'unidades') {
        this.pendingFocusSecao = 'unidades';
        this.highlightUnidadesField = true;
      }
      const split = this.$refs.detalheSplit;
      if (split && typeof split.abrirAbaParametros === "function") {
        split.abrirAbaParametros();
      }
      if (focusSecao === 'unidades') {
        this.$nextTick(() => {
          setTimeout(() => this.highlightSecaoUnidades(), 300);
        });
      }
    },
    editItemCerca(item) {
      this.itemCercas = Object.assign({}, item);
      this.editingCercaOriginal = {
        id_cerca: item.id_cerca,
        id_sentido: item.id_sentido,
      };
      this.showSinotico = this.itemCercas.show_sinotico == 1 ? 1 : 0;
      this.editingCerca = true;
      this.dialogCercas = true;
    },
    editItemRota(item) {
      this.itemRotas = Object.assign({}, item);
      this.editingRota = true;
      this.dialogRotas = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.confirmDialogType = 'delete';
      this.mensagemdialog = this.$t('crudLinhas.messages.confirmDeactivation', { code: item.cod_linha });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('crudLinhas.messages.no');
      this.messageConfirmButton = this.$t('crudLinhas.messages.yes');
      this.confirmDialog = true;
    },
    deleteItemParada(item) {
      this.paradas.splice(
        this.paradas.findIndex((a) => a.cod_parada === item.cod_parada),
        1
      );
      this.editedParadas = true;
    },
    deleteItemCerca(item) {
      this.cercasLinha.splice(
        this.cercasLinha.findIndex(
          (a) =>
            Number(a.id_cerca) === Number(item.id_cerca) &&
            Number(a.id_sentido) === Number(item.id_sentido)
        ),
        1
      );
      this.editedCercas = true;
    },
    deleteItemRota(item) {
      const calcAnterior = this.distanciasCalculadas;
      this.rotasLinha.splice(
        this.rotasLinha.findIndex((a) => a.id_rota === item.id_rota),
        1
      );
      this.editedRotas = true;
      this.calculaDistanciasLinha(calcAnterior);
    },
    deleteItemSublinha(item) {
      this.sublinhas.splice(
        this.sublinhas.findIndex((a) => a.id_linha === item.id_linha),
        1
      );
      this.editedSublinhas = true;
    },
    isLatitude(lat) {
      return lat != "" && isFinite(lat) && Math.abs(lat) <= 90;
    },
    isLongitude(lng) {
      return lng != "" && isFinite(lng) && Math.abs(lng) <= 180;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      const deletedId = this.deletedItem && this.deletedItem.id_linha;

      apiController.request(apiController.endpoints.deleteLinha, {
        data: this.deletedItem,
        onSuccess: (response) => {
          if (deletedId != null) {
            this.selecionadas = dropFromSelection(this.selecionadas, [deletedId], "id_linha");
          }
          this.updateTable(response.data.erro);
        },
      });
    },
    resetaLinha() {
      this.scopedClienteCreateLocked = false;
      this.lastConfirmedIdCliente = null;
      this.pendingIdCliente = null;
      this.suppressClienteConfirmChange = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.deletedItem = Object.assign({}, this.defaultItem);
      this.alarmeVelocidadeMaxima = false;
      this.alarmeTempoParado = false;
      this.alarmeForaRota = false;
      this.isAtiva = true;
      this.isCircular = false;
      this.atualizaInicioViagem = false;
      this.velocidadeMaxima = 0;
      this.limiteTempoParado = 0;
      this.limiteTempoLargada = 0;
      this.filteredRotas = [];
      this.paradas = [];
      this.cercasLinha = [];
      this.rotasLinha = [];
      this.sublinhas = [];
      this.unidadesLinhaIds = [];
      this.linhaPrincipal = null;
      this.cercasValidado = false;
      this.rotasValidado = false;
      this.isSublinha = false;
      this.editedParadas = false;
      this.editedCercas = false;
      this.editedSublinhas = false;
      this.editedRotas = false;
      this.editingCercaOriginal = null;
      this.tab = 0;
      this.itemRotas = Object.assign({}, this.defaultItemRotas);
    },
    closeParametros() {
      this.editedIndex = -1;
      this.resetaLinha();
      this.$nextTick(() => {
        const form = this.$refs.formCreate || this.$refs.formParametros;
        if (form && typeof form.resetValidation === "function") {
          form.resetValidation();
        }
      });
    },
    close({ fromMap } = {}) {
      const wasCreatingLinha = this.creatingLinha;
      const linhaParaRestaurar = this.linhaAntesDeCriar;
      this.creatingLinha = false;
      this.createValidationAttempted = false;
      this.linhaAntesDeCriar = null;
      this.clearCreateMapPreview();
      const wasCriandoCerca = this.creatingCercaNaLinha;
      this.creatingCercaNaLinha = false;
      this.cercaNaLinhaRotaId = null;
      const split = this.$refs.detalheSplit;
      if (!fromMap && split && typeof split.closeCreateDrawer === "function") {
        split.closeCreateDrawer({ silent: true });
      }
      if (wasCriandoCerca && split) {
        if (typeof split.setPickLocationMode === "function") split.setPickLocationMode(false);
        if (typeof split.setDrawPolygonMode === "function") split.setDrawPolygonMode(false);
        if (typeof split.clearCreateDraft === "function") split.clearCreateDraft();
        if (typeof split.setCercaCreateRouteId === "function") split.setCercaCreateRouteId(null);
      }
      this.pickLocationAtivoCerca = false;
      this.desenhoPoligonoAtivoCerca = false;
      this.resetNovaCercaForm();
      // Cancelou o cadastro de linha nova: volta a mostrar a linha que estava ativa
      // antes, com os controles do mapa completos (em vez da tela vazia de sele├º├úo).
      if (wasCreatingLinha && linhaParaRestaurar && this.pendingSelectIdLinha == null) {
        this.selecionarLinha(linhaParaRestaurar, { manterAba: true });
        return;
      }
      // Após salvar parâmetros de uma linha já selecionada, não zerar o formulário —
      // o reload da lista atualiza via watcher de linhaSelecionada. Evita flash vazio ~1s.
      const manterParametros =
        !wasCreatingLinha
        && this.linhaSelecionada
        && this.linhaSelecionada.id_linha != null;
      if (!manterParametros && !(wasCreatingLinha && this.pendingSelectIdLinha != null)) {
        this.closeParametros();
      }
    },
    closeDialogCercas() {
      this.dialogCercas = false;
      this.$nextTick(() => {
        this.itemCercas = Object.assign({}, this.defaultItemCercas);
        if (this.$refs.formCercas) {
          this.$refs.formCercas.resetValidation();
        }
        this.editingCerca = false;
        this.editingCercaOriginal = null;
      });
    },
    closeDialogRotas() {
      this.dialogRotas = false;
      this.$nextTick(() => {
        this.itemRotas = Object.assign({}, this.defaultItemRotas);
        if (this.$refs.formRotas) {
          this.$refs.formRotas.resetValidation();
        }
        this.editingRota = false;
      });
    },
    saveCercas() {
      const cercasToCheck = this.cercasLinha.filter(
        (c) =>
          !(
            this.editingCerca &&
            this.editingCercaOriginal &&
            Number(c.id_cerca) === Number(this.editingCercaOriginal.id_cerca) &&
            Number(c.id_sentido) === Number(this.editingCercaOriginal.id_sentido)
          )
      );
      const cercaExiste = cercasToCheck.some(
        (c) =>
          Number(c.id_cerca) === Number(this.itemCercas.id_cerca) &&
          this.cercaSentidosDuplicados(c.id_sentido, this.itemCercas.id_sentido)
      );
      if (cercaExiste) {
        EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.fenceAlreadyExists'), tipo: 'error' });
      } else {
        // Check for duplicate ponto inicial (tipo_cerca === 2) or ponto final (tipo_cerca === 3) for conflicting directions
        if (this.itemCercas.id_tipo_cerca === 2 || this.itemCercas.id_tipo_cerca === 3) {
          // When editing, exclude the current cerca from the check
          // Check for duplicate with same tipo_cerca AND conflicting sentido (direction)
          // Directions conflict if they overlap in IDA or VOLTA:
          // -1 (IDA E VOLTA) conflicts with any IDA (1,3,4) or VOLTA (2,5,6)
          // IDA (1,3,4) conflicts with -1 or other IDA (1,3,4)
          // VOLTA (2,5,6) conflicts with -1 or other VOLTA (2,5,6)
          const tipoCercaExists = cercasToCheck.findIndex((c) => 
            c.id_tipo_cerca === this.itemCercas.id_tipo_cerca && 
            this.sentidosConflictam(c.id_sentido, this.itemCercas.id_sentido)
          ) !== -1;
          
          if (tipoCercaExists) {
            const tipoCercaObj = this.tiposCerca.find((t) => t.id_tipo_cerca === this.itemCercas.id_tipo_cerca);
            const tipoNome = tipoCercaObj ? tipoCercaObj.descricao_tipo_cerca : 
              (this.itemCercas.id_tipo_cerca === 2 ? 'ponto inicial' : 'ponto final');
            const sentidoObj = this.sentidos.find((s) => s.id_sentido === this.itemCercas.id_sentido);
            const sentidoNome = sentidoObj ? sentidoObj.descricao_sentido : 'sentido';
            EventBus.$emit('show-alert', { 
              mensagem: this.$t("crudLinhas.messages.conflictDirection", { tipoNome: tipoNome, sentidoNome: sentidoNome }), 
              tipo: 'error' 
            });
            return;
          }
        }

        if (wouldBreakTerminusOrder(cercasToCheck, this.itemCercas, null, { rotas: this.rotasLinha })) {
          this.dialogTerminusOrder = true;
          return;
        }
        
        this.$refs.formCercas.validate();
        if (this.formValidadoCercas) {
          let tipoCerca = this.tiposCerca.find((t) => t.id_tipo_cerca === this.itemCercas.id_tipo_cerca);
          this.itemCercas.descricao_tipo_cerca = tipoCerca.descricao_tipo_cerca;
          this.itemCercas.cod_tipo_cerca = tipoCerca.codigo_cerca;
          this.itemCercas.nome_cerca = this.cercas.find((t) => t.id_cerca === this.itemCercas.id_cerca).nome_cerca;
          this.itemCercas.descricao_sentido = this.sentidos.find((s) => s.id_sentido === this.itemCercas.id_sentido).descricao_sentido;
          if (this.showSinotico !== null) {
            this.itemCercas.show_sinotico = this.showSinotico;
          }
          this.itemCercas.show_sinotico_extenso = this.itemCercas.show_sinotico == 1 ? this.$t('selectOptions.yes') : this.$t('selectOptions.no');
          if (this.editingCerca) {
            this.cercasLinha.splice(
              this.cercasLinha.findIndex(
                (a) =>
                  this.editingCercaOriginal &&
                  Number(a.id_cerca) === Number(this.editingCercaOriginal.id_cerca) &&
                  Number(a.id_sentido) === Number(this.editingCercaOriginal.id_sentido)
              ),
              1
            );
            this.cercasLinha.push(this.itemCercas);
          } else {
            this.cercasLinha.push(this.itemCercas);
          }
          this.dialogCercas = false;
          this.itemCercas = Object.assign({}, this.defaultItemCercas);
          this.editingCerca = false;
          this.editingCercaOriginal = null;
          if (this.$refs.formCercas) {
            this.$refs.formCercas.resetValidation();
          }
          this.editedCercas = true;
        }
      }
    },
    saveRotas() {
      this.$refs.formRotas.validate();
      if (this.formValidadoRotas) {
        const rota = this.rotas.find((r) => r.id_rota === this.itemRotas.id_rota);
        this.itemRotas.descricao_tipo_rota = rota ? rota.descricao_tipo_rota : null;
        this.itemRotas.nome_rota = rota ? rota.nome_rota : null;
        this.itemRotas.descricao_sentido = this.itemRotas.id_sentido ? this.sentidos.find((s) => s.id_sentido === this.itemRotas.id_sentido).descricao_sentido : null;
        this.itemRotas.shape = rota ? rota.shape : null;
        this.itemRotas.distancia = rota ? rota.distancia : null;
        const calcAnterior = this.distanciasCalculadas;
        if (this.editingRota) {
          this.rotasLinha.splice(
            this.rotasLinha.findIndex((a) => a.id_rota === this.itemRotas.id_rota),
            1
          );
          this.rotasLinha.push(this.itemRotas);
        } else {
          this.rotasLinha.push(this.itemRotas);
        }
        this.dialogRotas = false;
        this.itemRotas = Object.assign({}, this.defaultItemRotas);
        this.editingRota = false;
        if (this.$refs.formRotas) {
          this.$refs.formRotas.resetValidation();
        }
        this.editedRotas = true;
        this.calculaDistanciasLinha(calcAnterior);
      }
    },
    saveSublinhas() {
      this.$refs.formSublinhas.validate();
      if (this.formValidadoSublinhas) {
        if (this.editingSublinha) {
          this.sublinhas.splice(
            this.sublinhas.findIndex((a) => a.id_linha === this.sublinha.id_linha),
            1
          );
          this.sublinhas.push(this.sublinha);
        } else {
          this.sublinhas.push(this.sublinha);
        }
        this.editedSublinhas = true;
      }
    },
    normalizeCercasOrdemParada(cercasArray) {
      // Normalize ordem_parada for all cercas in the array
      // Ensures every cerca has a valid positive integer ordem_parada
      // Returns a new normalized and sorted array
      
      if (!cercasArray || cercasArray.length === 0) {
        return [];
      }
      
      // Create a working copy to avoid mutating the original
      const normalizedCercas = cercasArray.map(cerca => ({ ...cerca }));
      
      // First pass: find the maximum existing valid ordem_parada
      let maxOrdem = 0;
      for (let i = 0; i < normalizedCercas.length; i++) {
        const cerca = normalizedCercas[i];
        if (!cerca) continue;
        
        const ordem = cerca.ordem_parada;
        // Check if ordem_parada is valid (not null, not undefined, not 0, is a number, and > 0)
        if (ordem != null && ordem !== undefined && ordem !== 0 && ordem !== '' && !isNaN(ordem) && parseInt(ordem) > 0) {
          maxOrdem = Math.max(maxOrdem, parseInt(ordem));
        }
      }
      
      // Second pass: assign ordem_parada to cercas that don't have a valid one
      for (let i = 0; i < normalizedCercas.length; i++) {
        const cerca = normalizedCercas[i];
        if (!cerca) continue;
        
        const ordem = cerca.ordem_parada;
        
        // Check if ordem_parada is invalid
        if (ordem == null || ordem === undefined || ordem === 0 || ordem === '' || isNaN(ordem) || parseInt(ordem) < 1) {
          // Assign the next available ordem_parada
          maxOrdem++;
          cerca.ordem_parada = maxOrdem;
        } else {
          // Ensure it's a valid integer
          cerca.ordem_parada = parseInt(ordem);
        }
      }
      
      // Sort by ordem_parada to maintain order
      normalizedCercas.sort((a, b) => {
        const ordemA = a.ordem_parada || 0;
        const ordemB = b.ordem_parada || 0;
        return ordemA - ordemB;
      });
      
      return normalizedCercas;
    },
    insertCercasBulk(idlinha) {
      this.loadingInsertCercas = true;
      
      // Normalize ordem_parada for all cercas before processing
      const normalizedCercas = this.normalizeCercasOrdemParada(this.cercasLinha || []);
      if (hasTerminusOrderViolation(normalizedCercas, { rotas: this.rotasLinha })) {
        this.loadingInsertCercas = false;
        this.dialogTerminusOrder = true;
        return;
      }
      
      // Update this.cercasLinha with normalized values so UI reflects the changes
      this.cercasLinha = normalizedCercas;
      
      // IMPORTANT: Create a deep copy of normalized cercas BEFORE any operations
      // This prevents it from being cleared during async operations
      const cercasLinhaCopy = JSON.parse(JSON.stringify(normalizedCercas));
      
      let temp = [];
      for (let i = 0; i < normalizedCercas.length; i++) {
        const cerca = normalizedCercas[i];
        if (!cerca) continue;
        
        // Final safety check - should never be needed after normalization, but just in case
        const ordemParada = (cerca.ordem_parada != null && cerca.ordem_parada > 0) 
          ? parseInt(cerca.ordem_parada) 
          : (i + 1);
        
        temp.push([
          idlinha,
          cerca.id_cerca,
          cerca.id_tipo_cerca,
          cerca.show_sinotico,
          cerca.tempo_chegada_minutos,
          cerca.id_sentido,
          ordemParada
        ]);
      }
      apiController.request(apiController.endpoints.insertCercaslinhabulk, {
        data: temp,
        onSuccess: (response) => {
          if (cercasLinhaCopy.length > 0) {
            if (this.editedIndex === -1) {
              this.insertCercasVigencia(idlinha, cercasLinhaCopy);
            } else {
              this.updateCercasVigenciaOrdem(idlinha, cercasLinhaCopy);
            }
          } else {
            this.loadingInsertCercas = false;
            this.updateTable(response.data.erro);
          }
        },
        onError: () => {
          this.loadingInsertCercas = false;
        },
      });
    },
    insertCercasVigencia(idlinha, cercasLinhaCopy) {
      // Create vigencia with padrao=1 and ativa=1
      const vigenciaData = {
        vigencia: {
          id_linha: idlinha,
          data_inicio: null,
          hora_inicio: null,
          data_fim: null,
          hora_fim: null,
          padrao: 1,
          ativa: 1
        }
      };

      apiController.request(apiController.endpoints.insertCercavigenciacomsequencia, {
        data: vigenciaData,
        onSuccess: (response) => {
          if (response.data.erro) {
            console.error("Erro ao inserir vig├¬ncia:", response.data.mensagem);
            this.loadingInsertCercas = false;
            this.updateTable(response.data.erro);
          } else {
            const id_associacao = response.data.id_associacao;
            console.log("Vig├¬ncia criada com id_associacao:", id_associacao);
            this.insertCercasOrdem(id_associacao, cercasLinhaCopy);
          }
        },
        onError: () => {
          this.loadingInsertCercas = false;
          this.updateTable(true);
        },
      });
    },
    insertCercasOrdem(id_associacao, cercasLinhaCopy) {
      // Use the copy passed as parameter, or fall back to this.cercasLinha if not provided
      const cercasToProcess = cercasLinhaCopy || this.cercasLinha || [];
      
      // Safety check: ensure we have cercas to process
      if (!cercasToProcess || cercasToProcess.length === 0) {
        console.warn('insertCercasOrdem: cercasToProcess is empty');
        this.loadingInsertCercas = false;
        this.updateTable(false);
        return;
      }
      
      // Normalize ordem_parada for all cercas (same as insertCercasBulk)
      const normalizedCercas = this.normalizeCercasOrdemParada(cercasToProcess);

      // Build array of cercas ordem using the normalized ordem_parada
      let cercasOrdem = [];
      for (let i = 0; i < normalizedCercas.length; i++) {
        const cerca = normalizedCercas[i];
        if (!cerca) continue;
        
        // Get ordem_parada - should be normalized by now, but add final safety check
        let ordemParada = cerca.ordem_parada;
        
        // Final validation - ensure it's a valid positive integer
        if (ordemParada == null || ordemParada === undefined || ordemParada === 0 || ordemParada === '' || isNaN(ordemParada) || ordemParada < 1) {
          // This should never happen after normalization, but if it does, use index + 1
          ordemParada = i + 1;
          console.warn(`Warning: cerca ${cerca.id_cerca} had invalid ordem_parada after normalization, using ${ordemParada}`);
        } else {
          ordemParada = parseInt(ordemParada);
        }
        
        // Ensure all required fields are present
        if (!id_associacao || !cerca.id_cerca) {
          console.error(`Error: Missing required fields for cerca. id_associacao: ${id_associacao}, id_cerca: ${cerca.id_cerca}`);
          continue;
        }
        
        cercasOrdem.push([
          id_associacao,
          cerca.id_cerca,
          ordemParada,  // Use the validated integer value
          cerca.id_sentido || null,
          cerca.id_tipo_cerca || null
        ]);
      }

      // Check if we have any cercas to insert
      if (cercasOrdem.length === 0) {
        console.warn('insertCercasOrdem: No valid cercas to insert after validation');
        this.loadingInsertCercas = false;
        this.updateTable(false);
        return;
      }

      console.log(`insertCercasOrdem: Inserting ${cercasOrdem.length} cercas ordem with id_associacao: ${id_associacao}`);

      apiController.request(apiController.endpoints.insertCercaordembulk, {
        data: cercasOrdem,
        onSuccess: (response) => {
          console.log("Cercas ordem inseridas:", response.data);
          this.loadingInsertCercas = false;
          if (response.data.erro) {
            console.error("Erro ao inserir cercas ordem:", response.data.mensagem);
            EventBus.$emit('show-error', { error: { message: response.data.mensagem } });
          }
          this.updateTable(response.data.erro);
        },
        onError: (e) => {
          console.error("ERRO ao inserir cercas ordem:", e);
          if (e.response) {
            console.error("Response data:", e.response.data);
            console.error("Response status:", e.response.status);
          }
          this.loadingInsertCercas = false;
          this.updateTable(true);
        },
      });
    },
    updateCercasVigenciaOrdem(idlinha, cercasLinhaCopy) {
      apiController.request(apiController.endpoints.getCercaspadraoporlinha, {
        data: [idlinha],
        silent: true,
        onSuccess: (response) => {
          const padraoCercas = response.data || [];

          if (padraoCercas.length > 0) {
            const id_associacao = padraoCercas[0].id_associacao;

            if (id_associacao) {
              apiController.request(apiController.endpoints.deleteCercaordem, {
                params: { id_ordem: id_associacao },
                silent: true,
                onSuccess: () => {
                  this.insertCercasOrdem(id_associacao, cercasLinhaCopy);
                },
                onError: (e) => {
                  console.log("ERRO ao deletar cercas ordem");
                  this.loadingInsertCercas = false;
                  EventBus.$emit('show-error', { error: e });
                  this.updateTable(true);
                },
              });
            } else {
              this.insertCercasVigencia(idlinha, cercasLinhaCopy);
            }
          } else {
            this.insertCercasVigencia(idlinha, cercasLinhaCopy);
          }
        },
        onError: () => {
          console.log("ERRO ao buscar padrão vigência");
          this.insertCercasVigencia(idlinha, cercasLinhaCopy);
        },
      });
    },
    insertRotasBulk(idlinha) {
      this.loadingInsertRotas = true;
      let temp = [];
      for (let i = 0; i < this.rotasLinha.length; i++) {
        temp.push([
          idlinha,
          this.rotasLinha[i].id_rota,
          this.rotasLinha[i].id_tipo_rota,
          this.rotasLinha[i].id_sentido,
          1  // ativo = 1
        ]);
      }
      apiController.request(apiController.endpoints.insertRotaslinhabulk, {
        data: temp,
        onSuccess: (response) => {
          this.loadingInsertRotas = false;
          this.updateTable(response.data.erro);
        },
        onError: () => {
          this.loadingInsertRotas = false;
        },
      });
    },
    insertSublinhasBulk(idlinha) {
      this.loadingInsertSublinhas = true;
      if (this.sublinhas.length > 0) {
        let temp = {
          idsublinhas: this.sublinhas.map((s) => s.id_linha),
          idlinha: idlinha
        };

        apiController.request(apiController.endpoints.associaSublinhasbulk, {
          data: temp,
          onSuccess: (response) => {
            this.loadingInsertSublinhas = false;
            this.updateTable(response.data.erro);
          },
          onError: () => {
            this.loadingInsertSublinhas = false;
          },
        });
      } else {
        this.loadingInsertSublinhas = false;
        this.updateTable(false);
      }
    },
    updateCercas() {
      this.loadingInsertCercas = true;
      apiController.request(apiController.endpoints.deleteCercasbylinha, {
        data: this.editedItem,
        onSuccess: () => {
          this.insertCercasBulk(this.editedItem.id_linha);
        },
        onError: () => {
          this.loadingInsertCercas = false;
        },
      });
    },
    updateRotas() {
      this.loadingInsertRotas = true;
      apiController.request(apiController.endpoints.deleteRotaslinhabulk, {
        data: this.editedItem,
        onSuccess: () => {
          this.insertRotasBulk(this.editedItem.id_linha);
        },
      });
    },
    updateSublinhas() {
      this.loadingInsertSublinhas = true;
      apiController.request(apiController.endpoints.desassociaSublinhasbulk, {
        data: this.editedItem,
        onSuccess: () => {
          this.insertSublinhasBulk(this.editedItem.id_linha);
        },
      });
    },
    save() {
      if (this.creatingLinha) {
        this.createValidationAttempted = true;
      }
      const form = this.creatingLinha
        ? (this.$refs.formCreate || this.$refs.formParametros)
        : this.$refs.formParametros;
      if (form) form.validate();
      if (this.creatingLinha && !this.validateCreateAssociations()) return;

      if (this.formValidado) {
        this.editedItem.ativa = this.isAtiva == 1 ? 1 : 0;
        this.editedItem.circular = this.isCircular == 1 ? 1 : 0;
        this.editedItem.tolerancia_fora_rota =
          this.toleranciaForaRota != null && this.toleranciaForaRota !== ""
            ? Number(this.toleranciaForaRota)
            : 150;
        this.editedItem.alarme_fora_rota = this.alarmeForaRota == 1 ? 1 : 0;
        this.editedItem.alarme_velocidade_maxima =
          this.alarmeVelocidadeMaxima == 1 ? 1 : 0;
        this.editedItem.velocidade_maxima = Number(this.velocidadeMaxima);
        this.editedItem.alarme_tempo_parado =
          this.alarmeTempoParado == 1 ? 1 : 0;
        this.editedItem.atualiza_inicio_viagem =
          this.atualizaInicioViagem == 1 ? 1 : 0;
        
        this.editedItem.limite_tempo_parado =
          this.limiteTempoParado != null && this.limiteTempoParado !== ""
            ? Number(this.limiteTempoParado)
            : 0;
        this.editedItem.tempo_maximo_largada =
          this.limiteTempoLargada != null && this.limiteTempoLargada !== ""
            ? Number(this.limiteTempoLargada)
            : 15;
        // Vazio grava NULL: a linha volta a herdar o limite da unidade ou o global.
        this.editedItem.tempo_maximo_permanencia_linha_minutos =
          this.editedItem.tempo_maximo_permanencia_linha_minutos != null
            && this.editedItem.tempo_maximo_permanencia_linha_minutos !== ""
            ? Number(this.editedItem.tempo_maximo_permanencia_linha_minutos)
            : null;
        // Vazio grava NULL: a linha volta a herdar a velocidade da unidade ou a global.
        this.editedItem.velocidade_media_estimativa_kmh =
          this.editedItem.velocidade_media_estimativa_kmh != null
            && this.editedItem.velocidade_media_estimativa_kmh !== ""
            ? Number(this.editedItem.velocidade_media_estimativa_kmh)
            : null;
        this.editedItem.distancia_ida =
          this.editedItem.distancia_ida != null && this.editedItem.distancia_ida !== ""
            ? Number(this.editedItem.distancia_ida)
            : 0;
        this.editedItem.distancia_volta =
          this.editedItem.distancia_volta != null && this.editedItem.distancia_volta !== ""
            ? Number(this.editedItem.distancia_volta)
            : 0;
        this.editedItem.id_tipo_aberturas_viagens =
          this.editedItem.id_tipo_aberturas_viagens || 1;
        this.editedItem.has_eta = this.editedItem.has_eta ? 1 : 0;
        this.editedItem.linha_intermunicipal = this.editedItem.linha_intermunicipal ? 1 : 0;
        this.editedItem.lotacao_prevista =
          this.editedItem.lotacao_prevista != null && this.editedItem.lotacao_prevista !== ""
            ? Number(this.editedItem.lotacao_prevista)
            : 0;
        if (this.editedItem.id_rota === "" || this.editedItem.id_rota === undefined) {
          this.editedItem.id_rota = null;
        }
        // Vazio: o backend grava o id_linha como codigo de integracao.
        this.editedItem.cod_integracao_linha =
          this.editedItem.cod_integracao_linha != null
            && String(this.editedItem.cod_integracao_linha).trim() !== ""
            ? String(this.editedItem.cod_integracao_linha).trim()
            : null;
        this.editedItem.descricao_linha =
          this.editedItem.descricao_linha != null
            && String(this.editedItem.descricao_linha).trim() !== ""
            ? String(this.editedItem.descricao_linha).trim()
            : null;

        this.calculaDistanciasLinha();

        if (this.creatingLinha) {
          this.applyCreatePreviewToPersist();
        }

        if (this.editedItem.id_linha == null) {
          this.operacao = 0;
          this.editedIndex = -1;
          apiController.request(apiController.endpoints.insertLinha, {
            data: this.editedItem,
            silent: true,
            onSuccess: (response) => {
              if (response.data.erro) {
                console.error("Erro ao inserir linha:", response.data.mensagem);
                this.updateTable(true);
                return;
              }

              const insertId = response.data.insertId;
              if (insertId != null) {
                this.pendingSelectIdLinha = insertId;
                this.markLineAsRecentlyChanged(insertId);
              }

              const afterUnidades = () => {
                if (this.editedCercas) {
                  this.insertCercasBulk(insertId);
                }

                if (this.editedRotas) {
                  this.insertRotasBulk(insertId);
                }

                if (this.editedSublinhas) {
                  this.insertSublinhasBulk(insertId);
                }

                // Compara├º├úo/hist├│rico: agendada em updateTable ap├│s cercas/rotas persistirem
                // (e via hooks backend insertlinha / insertcercaslinhabulk).

                if (
                  !this.editedParadas,
                  !this.editedCercas,
                  !this.editedRotas,
                  !this.editedSublinhas
                ) {
                  this.updateTable(response.data.erro);
                }
              };

              this.syncUnidadesLinha(insertId)
                .then(afterUnidades)
                .catch(() => {
                  this.updateTable(true);
                });
            },
            onError: (e) => {
              console.log("ERRO ao inserir linha");
              console.log(e);
              if (e.response) {
                console.log("Response data:", e.response.data);
              }
              EventBus.$emit('show-error', { error: e });
              this.updateTable(true);
            },
          });
        } else {
          this.operacao = 1;
          this.editedIndex = 0;
          apiController.request(apiController.endpoints.updateLinha, {
            data: this.editedItem,
            silent: true,
            onSuccess: (response) => {
              this.markLineAsRecentlyChanged(this.editedItem.id_linha);
              const afterUnidades = () => {
                if (this.editedCercas) {
                  this.updateCercas();
                }

                if (this.editedRotas) {
                  this.updateRotas();
                }

                if (this.editedSublinhas) {
                  this.updateSublinhas();
                }

                // Compara├º├úo/hist├│rico: agendada em updateTable ap├│s cascata.

                if (
                  !this.editedParadas,
                  !this.editedCercas,
                  !this.editedRotas,
                  !this.editedSublinhas
                ) {
                  this.updateTable(response.data.erro);
                }
              };

              this.syncUnidadesLinha(this.editedItem.id_linha)
                .then(afterUnidades)
                .catch(() => {
                  /* erro j├í notificado em syncUnidadesLinha */
                });
            },
            onError: (e) => {
              console.log(this.$t('system.messages.errorAxios'));
              console.log(e.message);
              EventBus.$emit('show-error', { error: e });
            },
          });
        }
      } else {
        if (!this.formValidado) {
          this.tab = 0;
        }
      }
    },
    scheduleCompararDistanciaInformada(idLinha) {
      const id = idLinha != null ? Number(idLinha) : null;
      if (!Number.isFinite(id) || id <= 0) return;
      // Cercas j├í devem estar persistidas quando chamado a partir de updateTable.
      setTimeout(() => {
        apiController.request(apiController.endpoints.compararDistanciainformadalinha, {
          data: { id_linha: id, origem: 'CRUD_LINHAS', async: true },
          silent: true,
        });
      }, 500);
    },
    /**
     * Cadastro de linha exige pelo menos uma rota e, em cada rota, cercas de ponto
     * inicial (2) e ponto final (3) no sentido dela.
     */
    validateCreateAssociations() {
      if (!this.createPreviewRotas.length) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.messages.routeRequired"),
          tipo: "error",
        });
        return false;
      }
      const rotaSemTerminais = this.createPreviewRotas.some((rota) => {
        const cercas = this.createPreviewCercasLinha.filter((c) =>
          this.cercaSentidosDuplicados(c.id_sentido, rota.id_sentido)
        );
        return (
          !cercas.some((c) => Number(c.id_tipo_cerca) === 2) ||
          !cercas.some((c) => Number(c.id_tipo_cerca) === 3)
        );
      });
      if (rotaSemTerminais) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("crudLinhas.messages.fenceRequired"),
          tipo: "error",
        });
        return false;
      }
      return true;
    },
    validateCercas() {
      this.cercasValidado = this.cercasLinha.findIndex((c) => c.id_tipo_cerca === 2) !== -1 && this.cercasLinha.findIndex((c) => c.id_tipo_cerca === 3) !== -1
      if (!this.cercasValidado) {
        EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.fenceRequired'), tipo: 'error' });
        this.tab = 2;
      }
    },
    validateRotas() {
      this.rotasValidado = this.rotasLinha.findIndex((c) => c.id_tipo_rota === 1) !== -1
      if (!this.rotasValidado) {
        EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.routeRequired'), tipo: 'error' });
        this.tab = 3;
      }
    },
    updateTable(status) {
      if (this._isDestroyed) {
        return;
      }
      if (
        !this.loadingInsertCercas &&
        !this.loadingInsertRotas &&
        !this.loadingInsertSublinhas
      ) {
        if (status) {
          this.pendingSelectIdLinha = null;
          if (this.operacao == 0) {
            EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.errorInsert'), tipo: 'error' });
          } else {
            if (this.operacao == 1) {
              EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.errorUpdate'), tipo: 'error' });
            } else {
              EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.errorDelete'), tipo: 'error' });
            }
          }
        } else {
          const idParaComparar =
            this.pendingSelectIdLinha ||
            (this.editedItem && this.editedItem.id_linha) ||
            null;
          if ((this.operacao === 0 || this.operacao === 1) && idParaComparar) {
            this.scheduleCompararDistanciaInformada(idParaComparar);
          }
          if (this.operacao == 0) {
            EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.successInsert'), tipo: 'success' });
          } else {
            if (this.operacao == 1) {
              EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.successUpdate'), tipo: 'success' });
            } else {
              EventBus.$emit('show-alert', { mensagem: this.$t('crudLinhas.messages.successDelete'), tipo: 'success' });
            }
          }
        }
        // Only close dialog if it was open (for insert/update operations)
        // For delete operations, the dialog is never opened, so we shouldn't try to close it
        if (this.operacao !== 2) {
          this.close();
        } else {
          // For delete, just reset the state without closing dialog
          this.editedIndex = -1;
          this.resetaLinha();
        }
        this.initialize();
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`
    },
    calculaDistancia(lat1, lat2, lon1, lon2) {
      if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
      } else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) { dist = 1; }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        return dist * 1000;
      }
    },
    calculaDistanciaTotalShape(shape) {
      var distTotal = 0;
      if (shape == "" || shape == null) {
        return distTotal;
      }

      if (shape.length > 0) {
        for (var i = 1; i < shape.length; i++) {
          let dist = this.calculaDistancia(shape[i - 1].lt, shape[i].lt, shape[i - 1].lg, shape[i].lg);
          distTotal += dist;
        }
      }
      return distTotal;
    },
    getPonto(ponto) {
      const array = JSON.parse(this.editedItem.shape).filter((s) => s.sentido === 'IDA');
      return array.reduce((prev, curr) => {
        return (this.calculaDistancia(ponto.lt, prev.lt, ponto.lg, prev.lg) < this.calculaDistancia(ponto.lt, curr.lt, ponto.lg, curr.lg) ? prev : curr);
      });
    },
    /**
     * Normaliza o shape da rota para [{ lt, lg }, ...].
     */
    parseShapePontos(shape) {
      if (shape == null || shape === "") return [];
      let parsed = shape;
      if (typeof shape === "string") {
        try {
          parsed = JSON.parse(shape);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(parsed) || !parsed.length) return [];
      return parsed
        .map((p) => {
          if (!p || typeof p !== "object") return null;
          const lt = Number(p.lt != null ? p.lt : p.lat);
          const lg = Number(p.lg != null ? p.lg : p.lng);
          if (!Number.isFinite(lt) || !Number.isFinite(lg)) return null;
          return { lt, lg };
        })
        .filter(Boolean);
    },
    /**
     * Dist├óncia de uma rota em metros.
     * Prefere `distancia` cadastrada (metros no Verso/OSRM); sen├úo mede o shape.
     */
    distanciaRotaMetros(rota) {
      if (!rota) return 0;
      const stored = Number(rota.distancia);
      if (Number.isFinite(stored) && stored > 0) return stored;
      return this.calculaDistanciaTotalShape(this.parseShapePontos(rota.shape));
    },
    /**
     * Soma km das rotas de um sentido (principal + deslocamento, se houver).
     */
    somaDistanciaRotasKm(rotas, idSentido) {
      const list = Array.isArray(rotas) ? rotas : [];
      const metros = list
        .filter((r) => Number(r && r.id_sentido) === Number(idSentido))
        .reduce((acc, r) => acc + this.distanciaRotaMetros(r), 0);
      return Number((metros / 1000).toFixed(5));
    },
    /**
     * distancia_ida / distancia_volta = soma das rotas do sentido (inclui deslocamentos).
     * Em linha circular, se n├úo houver volta, replica a ida.
     */
    calculaDistanciasFromRotas(rotas, circular) {
      let distancia_ida = this.somaDistanciaRotasKm(rotas, 1);
      let distancia_volta = this.somaDistanciaRotasKm(rotas, 2);
      const isCircular = circular === true || circular === 1 || Number(circular) === 1;
      if (isCircular && distancia_volta <= 0 && distancia_ida > 0) {
        distancia_volta = distancia_ida;
      }
      return { distancia_ida, distancia_volta };
    },
    distanciasDiferem(a, b) {
      return Number(a || 0).toFixed(5) !== Number(b || 0).toFixed(5);
    },
    /**
     * A distância informada pelo usuário (km nominal) prevalece sobre a calculada.
     * Só acompanha o cálculo das rotas o campo vazio/zerado ou o que ainda coincidia
     * com o cálculo anterior (`calcAnterior`), isto é, que nunca foi ajustado à mão.
     */
    mesclaDistanciasInformadas(atuais, calcAnterior, calcNovo) {
      const out = {};
      ["distancia_ida", "distancia_volta"].forEach((campo) => {
        const atual = Number(atuais && atuais[campo]);
        const segueCalculo = !Number.isFinite(atual) || atual <= 0
          || (!!calcAnterior && !this.distanciasDiferem(atual, calcAnterior[campo]));
        out[campo] = segueCalculo ? calcNovo[campo] : atual;
      });
      return out;
    },
    calculaDistanciasLinha(calcAnterior = null) {
      if (!this.editedItem) return;
      const dists = this.mesclaDistanciasInformadas(this.editedItem, calcAnterior, this.distanciasCalculadas);
      this.editedItem.distancia_ida = dists.distancia_ida;
      this.editedItem.distancia_volta = dists.distancia_volta;
    },
    /** Aviso (não bloqueante) de que o km informado difere do calculado pelas rotas. */
    avisoDistancia(campo) {
      const calc = Number(this.distanciasCalculadas[campo]);
      const informada = Number(this.editedItem && this.editedItem[campo]);
      if (!(calc > 0) || !(informada > 0) || !this.distanciasDiferem(informada, calc)) return "";
      return this.$t("crudLinhas.form.fields.distanceDiffersFromCalculated", {
        km: calc.toLocaleString(this.$i18n.locale, { maximumFractionDigits: 5 }),
      });
    },
    usarDistanciaCalculada(campo) {
      this.editedItem[campo] = this.distanciasCalculadas[campo];
    },
    applyDistanciasToLinhaLocal(idLinha, dists) {
      const id = Number(idLinha);
      if (!Number.isFinite(id)) return;
      const row = (this.linhas || []).find((l) => Number(l.id_linha) === id);
      if (row) {
        this.$set(row, "distancia_ida", dists.distancia_ida);
        this.$set(row, "distancia_volta", dists.distancia_volta);
      }
      if (this.linhaSelecionada && Number(this.linhaSelecionada.id_linha) === id) {
        this.$set(this.linhaSelecionada, "distancia_ida", dists.distancia_ida);
        this.$set(this.linhaSelecionada, "distancia_volta", dists.distancia_volta);
      }
      if (this.editedItem && Number(this.editedItem.id_linha) === id) {
        this.editedItem.distancia_ida = dists.distancia_ida;
        this.editedItem.distancia_volta = dists.distancia_volta;
      }
    },
    /**
     * Ap├│s alterar rotas no painel de detalhe, recalcula e persiste as dist├óncias da linha.
     */
    async sincronizarDistanciasLinhaSelecionada() {
      const linha = this.linhaSelecionada;
      const idLinha = linha && linha.id_linha != null ? Number(linha.id_linha) : null;
      if (!Number.isFinite(idLinha) || idLinha <= 0) return;
      try {
        const res = await apiController.request(apiController.endpoints.getRotaspadraoporlinha, {
          data: [idLinha],
          silent: true,
        });
        const rotas = Array.isArray(res.data) ? res.data : [];
        const calcAnterior = this.calculaDistanciasFromRotas(this.rotasLinha, linha.circular);
        this.rotasLinha = rotas;
        const dists = this.mesclaDistanciasInformadas(
          linha,
          calcAnterior,
          this.calculaDistanciasFromRotas(rotas, linha.circular)
        );
        this.applyDistanciasToLinhaLocal(idLinha, dists);

        if (!this.canEdit) return;

        const payload = Object.assign({}, linha, {
          distancia_ida: dists.distancia_ida,
          distancia_volta: dists.distancia_volta,
        });
        await apiController.request(apiController.endpoints.updateLinha, {
          data: payload,
          silent: true,
        });
      } catch (e) {
        console.warn("Falha ao sincronizar dist├óncias da linha", e);
      }
    },
    tipoCercaChanged() {
      if (this.itemCercas.id_tipo_cerca == 2 || this.itemCercas.id_tipo_cerca == 3) {
        this.showSinotico = true;
      } else {
        this.showSinotico = false;
      }
    },
    linhaPrincipalChanged() {
      if (this.linhaPrincipal) {
        this.preencheLinha(this.linhaPrincipal);
        this.editedItem.id_linha = null;
        this.editedItem.nome_linha = "";
        this.editedItem.cod_linha = "";
        this.editedItem.id_linha_principal = this.linhaPrincipal.id_linha;
        this.sublinhas = [];
      } else {
        this.resetaLinha();
        if (this.$refs.formParametros) {
          this.$refs.formParametros.resetValidation();
        }
      }
    },
    isSublinhaChanged() {
      if (!this.isSublinha) {
        this.linhaPrincipal = null;
        this.resetaLinha();
        if (this.$refs.formParametros) {
          this.$refs.formParametros.resetValidation();
        }
        this.formValidado = false;
      }
    },
    horarioInicioRules(hora) {
      if (hora == null) {
        return this.$t('datetime.requiredTime');
      }
      else {
        if (hora.length === 0) {
          return this.$t('datetime.requiredTime');
        }
        else {
          if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
            return this.$t('datetime.invalidTime');
          }
          else {
            return true;
          }
        }
      }
    },
    horarioFimRules(hora) {
      if (hora == null) {
        return this.$t('datetime.requiredTime');
      }
      else {
        if (hora.length === 0) {
          return this.$t('datetime.requiredTime');
        }
        else {
          if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
            return this.$t('datetime.invalidTime');
          }
          else {
            return true;
          }
        }
      }
    },
    tempoChegadaRules() {
      if (this.itemCercas.tempo_chegada_minutos === null) {
        return true;
      }

      if (this.itemCercas.tempo_chegada_minutos < 0) {
        return this.$t('crudLinhas.validation.arrivalTimeMustBeGreaterThanZero');
      }

      return true;
    },
    ordemParadaRules() {
      if (this.itemCercas.ordem_parada === null || this.itemCercas.ordem_parada === "" || this.itemCercas.ordem_parada === undefined) {
        return "Ordem ├® obrigat├│ria";
      }

      const ordem = parseInt(this.itemCercas.ordem_parada);
      if (isNaN(ordem) || ordem <= 0) {
        return "Ordem deve ser maior que zero";
      }

      return true;
    },
    isSentidoIda(idSentido) {
      // IDA: 1, 3, 4
      return idSentido === 1 || idSentido === 3 || idSentido === 4;
    },
    isSentidoVolta(idSentido) {
      // VOLTA: 2, 5, 6
      return idSentido === 2 || idSentido === 5 || idSentido === 6;
    },
    isSentidoAmbos(idSentido) {
      // IDA E VOLTA: -1
      return idSentido === -1;
    },
    cercaSentidosDuplicados(sentido1, sentido2) {
      const primeiro = Number(sentido1);
      const segundo = Number(sentido2);
      return primeiro === segundo || primeiro === -1 || segundo === -1;
    },
    sentidosConflictam(sentido1, sentido2) {
      // Check if two sentidos conflict (overlap in IDA/VOLTA)
      if (sentido1 === sentido2) return true;
      
      const sentido1Ida = this.isSentidoIda(sentido1) || this.isSentidoAmbos(sentido1);
      const sentido1Volta = this.isSentidoVolta(sentido1) || this.isSentidoAmbos(sentido1);
      const sentido2Ida = this.isSentidoIda(sentido2) || this.isSentidoAmbos(sentido2);
      const sentido2Volta = this.isSentidoVolta(sentido2) || this.isSentidoAmbos(sentido2);
      
      // Conflict if both cover IDA or both cover VOLTA
      return (sentido1Ida && sentido2Ida) || (sentido1Volta && sentido2Volta);
    },
  },
};
</script>

<style>
.crud-linhas-distancia--divergente .v-messages__message {
  color: #fb8c00 !important;
}
/* Fora de scoped: dialog fullscreen do Vuetify pode sair do escopo do componente. */
.crud-linhas-label--highlight,
.crud-linhas-field--highlight-label .v-label,
.crud-linhas-field--highlight-label .v-icon,
.crud-linhas-field--highlight-label .v-messages__message,
.crud-linhas-field--highlight-label .v-text-field__details {
  color: #d60000 !important;
  caret-color: #d60000;
}
.crud-linhas-field--highlight-label.v-text-field > .v-input__control > .v-input__slot:before,
.crud-linhas-field--highlight-label.v-text-field > .v-input__control > .v-input__slot:after {
  border-color: #d60000 !important;
}
.crud-linhas-field--highlight-label.v-input--is-focused > .v-input__control > .v-input__slot:before,
.crud-linhas-field--highlight-label.v-input--is-focused > .v-input__control > .v-input__slot:after {
  border-color: #d60000 !important;
}
</style>
